
import {
  Input,
  InputNumber,
  message,
  Popconfirm,
  Upload,
  Select,
  PageHeader,
  Spin,
  Row,
  Col,
  Form as FormInitial,
  Tag,
  Divider,
  Tooltip,
  Typography,
  Checkbox,
  Card,
  Table,
  Button,
  Alert,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  PictureOutlined,
  EyeOutlined,
  CalculatorFilled,
  CopyOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ModalItem,
  DatePickerItem,
  InputNumberItem,
  SelectItem,
  dineroDisabledMask,
  ButtonItem,
  InputItem,
  BoxItem,
  TextAreaItem,
  cuentaMask,
  SwitchItem,
  ErrorItem,
  SelectInsumosItem,
  CheckItem,
  TableItem,
  round10Decimals,
  SelectValorCategoriaItem,
} from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import AgregarUnidad from "../AgregarInsumo/AgregarUnidad/AgregarUnidad";
import AsignarProveedor from "../../Requisiciones/AsignarProveedor/AsignarProveedor";
import AgregarControlLogistica from "./AgregarControlLogistica/AgregarControlLogistica";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import moment from "moment";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import ModalBusquedaURREA from "../AgregarInsumo/ModalBusquedaURREA/ModalBusquedaURREA";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import SelectUbicacionesProyectoItem from "../../../../Components/SelectUbicacionesProyectoItem";
import GeneralFormLayout from '../../../../Components/GeneralFormLayout';
import RichTextEditor from "../../../../Components/RichTextEditor";
import TabbedDynamicTable from '../../../../Components/TabbedDynamicTable';
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import MandarCorreo from "../../Ventas/MandarCorreo/MandarCorreo";
import MandarCorreoOrdenDeCompra from "../../OrdenesDeCompras/MandarCorreoOrdenDeCompra/MandarCorreoOrdenDeCompra";
import ModalMandarCorreoFacturas from "../../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import DiagramaConversion, {
  AZUL_BIWO,
  AZUL_BIWO_BG,
  LIMA_BIWO,
  LIMA_BIWO_BG,
} from "../../../../Components/DiagramaConversion";
const { Option } = Select;
const { Text } = Typography;
const estiloControlSugerido = {
  width: 90,
  borderColor: '#e08a2e',
  backgroundColor: 'rgba(224,138,46,0.12)',
};
const { Search } = Input;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

// Prompt de ejemplo para generar con IA la descripción web (HTML) de un insumo.
const PROMPT_DESCRIPCION_INSUMO_HTML = `Genera el contenido HTML de la DESCRIPCIÓN de un producto/insumo para la ficha de una tienda online. El HTML se renderiza dentro de un contenedor con la clase "prose" de Tailwind Typography, así que los títulos, párrafos, listas y enlaces YA se ven bien sin clases. Describe el producto de forma atractiva y vendedora: para qué sirve, beneficios, características técnicas, materiales, usos recomendados, etc. Reglas:

ESTRUCTURA
- Devuelve SOLO el contenido (sin <html>, <head>, <body>, <style>, <script>).
- Usa HTML semántico: <h2>, <h3>, <p>, <ul>, <ol>, <li>, <strong>, <em>, <a href="..." target="_blank" rel="noopener noreferrer">, <hr>, <blockquote>.
- NO uses <h1> (el nombre del producto ya lo pone el sistema).
- Una buena descripción suele incluir: un párrafo introductorio, una lista de características o beneficios, y opcionalmente una tabla/lista de especificaciones técnicas.

══════════════════════════════════════════════════════════════════
COLORES — hay DOS formas, según el color que quieras:
══════════════════════════════════════════════════════════════════
1) COLORES DE LA MARCA → usa CLASES de Tailwind (de la lista permitida):
   Texto: text-primary-700 text-primary-500 text-secondary-700 text-tertiary-700
   Fondo: bg-primary-50 bg-primary-500 bg-secondary-50 bg-tertiary-50
   Ejemplo: <p class="text-primary-700 font-semibold">Texto en color de marca</p>

2) CUALQUIER OTRO COLOR → usa ESTILO INLINE (no una clase):
   Texto: <span style="color: #e60000;">...</span>
   Fondo: <span style="background-color: #fff3cd;">...</span>
   Ejemplo: <p style="color: #6b21a8;">Texto en un morado personalizado</p>

REGLA: en un mismo elemento NO mezcles clase de color Y style de color
(si pones ambos, gana el inline). Elige uno por elemento.
══════════════════════════════════════════════════════════════════

CLASES TAILWIND PERMITIDAS (para todo lo demás: tamaño, espaciado, layout)
- Alineación: text-left text-center text-right text-justify
- Tamaño/peso: text-sm text-base text-lg text-xl text-2xl text-3xl font-medium font-semibold font-bold italic uppercase tracking-wide leading-relaxed leading-loose
- Colores texto marca: text-primary-700 text-primary-500 text-secondary-700 text-tertiary-700 text-neutral-500 text-neutral-600 text-neutral-700 text-white
- Fondos marca: bg-primary-50 bg-primary-500 bg-secondary-50 bg-tertiary-50 bg-neutral-50 bg-neutral-100 bg-white
- Bordes/radio: border border-2 border-l-4 border-primary-500 border-neutral-200 rounded rounded-lg rounded-xl
- Espaciado: p-2 p-3 p-4 p-6 px-4 py-2 py-3 my-4 my-6 mb-4 mt-4
- Layout: flex items-center gap-2 gap-3 grid grid-cols-2 w-full
- Sombras: shadow-sm shadow shadow-md
- Listas: list-disc list-decimal list-inside

PROHIBIDO
- NO inventes CLASES fuera de la lista de arriba (no se genera el CSS y no se ven). Esto aplica a clases; los colores libres SÍ se permiten, pero SOLO vía style inline.
- NO uses colores arbitrarios como CLASE (text-[#123456] no funciona) → usa style inline.
- NO uses px arbitrarios tipo p-[15px]; solo los valores de espaciado listados.

IDEAS DE ESTILO
- Lista de beneficios destacada con color de marca:
  <div class="bg-primary-50 border-l-4 border-primary-500 p-4 rounded-lg my-6">
    <p class="text-primary-700 font-semibold">Característica destacada del producto.</p>
  </div>
- Caja de especificaciones con color libre (inline):
  <div style="background-color: #fff3cd; border-left: 4px solid #f59e0b;" class="p-4 rounded-lg my-6">
    <p style="color: #92400e;" class="font-semibold">Nota o garantía importante.</p>
  </div>
- Usa <hr> para separar secciones grandes.

Describe el siguiente producto: [escribe aquí el nombre y los datos del insumo].`;

// Wrapper para el editor de Desc. Web que permite alternar entre editor visual y HTML crudo
function DescripcionWebEditor({ value, onChange }) {
  const [htmlMode, setHtmlMode] = React.useState(false);

  const toggleMode = () => setHtmlMode((prev) => !prev);

  const copiarPrompt = () => {
    const exito = () => message.success("Prompt copiado al portapapeles");
    const fallo = () => message.error("No se pudo copiar el prompt");

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(PROMPT_DESCRIPCION_INSUMO_HTML).then(exito, fallo);
    } else {
      try {
        const ta = document.createElement("textarea");
        ta.value = PROMPT_DESCRIPCION_INSUMO_HTML;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        exito();
      } catch (e) {
        fallo();
      }
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <Tooltip title="Copiar prompt de ejemplo para generar la descripción con IA">
          <button
            type="button"
            onClick={copiarPrompt}
            style={{
              fontSize: 12,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '2px 6px',
              border: 'none',
              background: 'transparent',
              color: '#8c8c8c',
              cursor: 'pointer',
            }}
          >
            <CopyOutlined /> Prompt IA
          </button>
        </Tooltip>
        <button
          type="button"
          onClick={toggleMode}
          style={{
            fontSize: 12,
            padding: '2px 10px',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            background: htmlMode ? '#1890ff' : '#fff',
            color: htmlMode ? '#fff' : '#595959',
            cursor: 'pointer',
          }}
        >
          {htmlMode ? 'Vista visual' : 'HTML crudo'}
        </button>
      </div>
      {htmlMode ? (
        <textarea
          value={value || ''}
          onChange={(e) => onChange?.(e.target.value)}
          rows={8}
          style={{
            width: '100%',
            fontFamily: 'monospace',
            fontSize: 12,
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            padding: 8,
            resize: 'vertical',
            boxSizing: 'border-box',
          }}
          placeholder="Escribe HTML aquí... "
        />
      ) : (
        <RichTextEditor
          value={value || ''}
          onChange={onChange}
          placeholder="Descripción para la tienda en línea"
          height={100}
          style={{ width: '100%' }}
        />
      )}
    </div>
  );
}

const equivalenciaEjemplos = [
  { presentacion: "Caja",      cantPres: 1,  base: "Pieza",  cantBase: 12,   factor: 12 },
  { presentacion: "Docena",    cantPres: 1,  base: "Pieza",  cantBase: 12,   factor: 12 },
  { presentacion: "Galón",     cantPres: 1,  base: "Litro",  cantBase: 3.785, factor: 3.785 },
  { presentacion: "Tonelada",  cantPres: 1,  base: "kg",     cantBase: 1000, factor: 1000 },
  { presentacion: "Pallet",    cantPres: 1,  base: "Caja",   cantBase: 20,   factor: 20 },
  { presentacion: "Pack 6",    cantPres: 1,  base: "Lata",   cantBase: 6,    factor: 6 },
  { presentacion: "Litro",     cantPres: 1,  base: "mL",     cantBase: 1000, factor: 1000 },
  { presentacion: "Metros",    cantPres: 10, base: "cm",     cantBase: 1000, factor: 100 },
];

// Agrupa las categorias hoja bajo el nombre de su categoria principal. Se calcula una sola
// vez al cargar el tab en vez de en cada render, porque este componente re-renderiza mucho
// y antes esto corria dentro de un IIFE en render().
const agruparCategorias = (categorias, principalesMap) => {
  const grupos = new Map();
  const sueltas = [];
  categorias.forEach((cat) => {
    const padreId = cat.categoriaPadreId ? cat.categoriaPadreId.toString() : null;
    const padreNombre = padreId ? principalesMap[padreId] : null;
    if (padreNombre) {
      if (!grupos.has(padreId)) {
        grupos.set(padreId, { padreId, nombre: padreNombre, hijas: [] });
      }
      grupos.get(padreId).hijas.push(cat);
    } else {
      sueltas.push(cat);
    }
  });
  return { grupos: [...grupos.values()], sueltas };
};

class EditarInsumo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    ubicacionesPredeterminadas: [],
    relacionesSeleccionadas: [],
    loadingEnvios: false,
    buscarInfoCode: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    todasMonedas: null,
    objetoMonedas: null,
    todasUnidades: null,
    objetoUnidades: null,
    todasImpuestos: null,
    objetoImpuestos: null,
    todasFamilia: null,
    objetoFamilia: null,
    todasProveedores: null,
    objetoProveedores: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    modalAgregarUnidad: false,
    modalAgregarFamilia: false,
    modalAsignarProveedor: false,
    modalAgregarControlLogistica: false,
    precios: [],
    calcularPreciosAutomaticamente: false,
    calcularPreciosSobre: false,
    noRecalcularPreciosAlEditarCosto: false,
    utilizado: false,
    // Las equivalencias ocultas (estado 0) NO van en el Form.List: el backend interpreta
    // "no vino en el payload" como "ocultala", asi que si entraran al formulario el primer
    // guardado las reviviria solas. Viven aparte y se restauran con el boton Restaurar.
    equivalenciasOcultas: [],
    mostrarEquivalenciasOcultas: false,
    modalAgregarCuentaContable: false,
    todasCuentasContablesFinales: null,
    objetoCuentasContablesFinales: null,
    impuestoCombustible: false,
    id: this.props.location.state.id,
    todasMaterialesPeligrosos: null,
    objetoMaterialesPeligrosos: null,
    todasEmbalajes: null,
    objetoEmbalajes: null,
    todasSectoresCOF: null,
    objetoSectoresCOF: null,
    todasFormasFarmaceuticas: null,
    objetoFormasFarmaceuticas: null,
    todasCondicionesEspeciales: null,
    objetoCondicionesEspeciales: null,
    todasTiposMaterias: null,
    objetoTiposMaterias: null,
    familiaGastoNoDeducible: false,
    unidadPeso: null,
    loadingLogistica: false,
    loadingExistencias: false,
    existencias: [],
    equivalenciasExistencias: [],
    ventasPProyecto: [],
    entregasPProveedor: [],
    controlesPropuestos: [],
    controlesDadosDeAlta: [],
    controlesFilas: [],
    tiempoEntregaManualDias: null,
    guardandoTiempoEntregaManual: false,
    inventariable: true,
    objetoTipoDeInsumo: null,
    todasTipoDeInsumo: [],
    buscarInfoCodeRA: [],
    objetoCodigoSatRA: [],
    todasCodigoSatRA: [],
    todasMarcas: [],
    objetoMarcas: null,
    apiURREA: false,
    insumoURREA: false,
    modalBusquedaURREA: false,
    codigoURREA: null,
    productoSeleccionado: null,
    codigoSatSeleccionado: null,
    venta: false,
    ventaOnline: false,
    ventaOnlineInsumo: false,
    historialCostos : [],
    permitirCompra : false, 
    todosUsuarios: null,
    imprimirImagenesCotizaciones : false,
    codBarObligatorio: false,
    kardex: [],
    loadingKardex: false,
    proyectoKardex: 0,
    todasProyectosKardex: [],
    objetoProyectosKardex: null,
    kardexCargado: false,
    mostrarApartados: false,
    // Drill-down del Kardex al documento de origen del renglon.
    modalCorreoVenta: false,
    modalCorreoVentaId: null,
    modalCorreoOrdenCompra: false,
    modalCorreoOrdenCompraId: null,
    modalCorreoFacturaCompra: false,
    modalCorreoFacturaCompraId: null,
    proyecciones: null,
    loadingProyecciones: false,
    agruparProyecciones: true,
    loadingCategorias: false,
    valoresPorCategoria: {},
    datosCategoriasIniciales: null,
    // Las categorias se cargan hasta que se abre su tab (ver cargarCategoriasDeTab).
    // hayCategoriasInsumo viene de selectDatosParaInsumo y decide si el tab se muestra;
    // categoriasCargadas indica si ya se hidrato el formulario, y de eso depende que
    // onFinish mande lo del form o reenvie los datosCategorias originales.
    hayCategoriasInsumo: false,
    categoriasCargadas: false,
    familiaCategoriasCargada: null,
    gruposCategorias: { grupos: [], sueltas: [] },
    equivModal: { visible: false, idx: null },
    equivModalMostrarEjemplos: false,
    equivCalcCantPres: [],
    equivCalcCantBase: [],
  };
  componentDidMount() {
    this.consultarTodo();
  }
  atras() {
    this.props.history.goBack();
  }
  async consultarTodo(e) {
    this.setState({ loading: true });
    let preciosConfig;
    let calcularPreciosSobre;
    // Disparar las peticiones independientes de inmediato (en paralelo) y esperarlas/procesarlas
    // en el mismo orden de siempre mas abajo, para no alterar las dependencias entre sus resultados
    // (p. ej. preciosConfig/calcularPreciosSobre se calculan aqui y los usa el .then de datosInsumo).
    const peticionSelectDatosParaInsumo = axios.post(
      "insumos/selectDatosParaInsumo",
      { empresaId: this.props.empresaId, paraEditar: true },
      {
        headers: this.props.headersToken,
      }
    );
    const peticionCuentasContablesFinales = axios.post(
      "cuentascontables/selectCuentasContablesFinales",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );
    const peticionDatosInsumo = !e
      ? axios.post(
          "insumos/datosInsumo",
          {
            empresaId: this.props.empresaId,
            insumoId: this.state.id,
          },
          { headers: this.props.headersToken }
        )
      : null;
    await peticionSelectDatosParaInsumo
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          preciosConfig = res.data.configuracion.precios.map((value) => {
            return {
              porcentajeFijo: value.porcentaje,
              porcentaje: value.porcentaje,
              nombre: value.nombre,
              precioId: value._id,
            };
          });
          calcularPreciosSobre = res?.data?.configuracion?.calcularPreciosSobre;
          this.setState(
            {
              todasGrupoSat: res.data.subclases,
              todasProveedores: res.data.proveedores,
              todasRetenciones: res.data.retenciones,
              todasImpuestos: res.data.impuestos,
              todasFamilia: res.data.familias,
              todasMonedas: res.data.monedas,
              todasUnidades: res.data.unidades,
              todasTipoDeInsumo: res.data.tiposInsumos,
              todasMarcas: res.data.marcas,
              hayCategoriasInsumo: !!res.data.hayCategoriasInsumo,
              calcularPreciosAutomaticamente:
                res.data.configuracion.calcularPreciosAutomaticamente,
              calcularPreciosSobre: res.data.configuracion.calcularPreciosSobre,
              noRecalcularPreciosAlEditarCosto:
                !!res.data.configuracion.noRecalcularPreciosAlEditarCosto,
              apiURREA: res.data.configuracion.apiURREA,
              ventaOnline: res.data.configuracion.ventaOnline,
              imprimirImagenesCotizaciones : res.data.configuracion.imprimirImagenesCotizaciones, 
              codBarObligatorio: res.data.configuracion.codBarObligatorio,
              precios: res.data.configuracion.precios.map((value) => {
                return {
                  porcentajeFijo: value.porcentaje,
                  porcentaje: value.porcentaje,
                  nombre: value.nombre,
                  precioId: value._id,
                };
              }),
              objetoUnidades: res.data.unidades.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
                  </Option>
                );
              }),
              objetoMonedas: res.data.monedas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.abreviacion}
                  </Option>
                );
              }),
              objetoFamilia: res.data.familias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoImpuestos: res.data.impuestos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoRetenciones: res.data.retenciones.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoProveedores: res.data.proveedores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              objetoTipoDeInsumo: res.data.tiposInsumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoMarcas: res.data.marcas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            },
            () => {
              this.formRef.current.setFieldsValue({
                codigo: res.data.sigNumero,
                clave: res.data.sigNumero,
                precios: res.data.configuracion.precios.map((value) => {
                  return {
                    porcentajeFijo: value.porcentaje,
                    porcentaje: value.porcentaje,
                    nombre: value.nombre,
                    precioId: value._id,
                  };
                }),
              });
            }
          );
        }
      });
    await peticionCuentasContablesFinales
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentasContablesFinales: res.data });
          this.setState({
            objetoCuentasContablesFinales: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    if (!e) {
      let datosInsumo;
      await peticionDatosInsumo
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion del insumo");
          } else {
            if (res.data.utilizado) {
              message.info(
                "No se puede modificar toda la informacion ya que el insumo ya fue utilizado"
              );
            }
            this.setState({ venta: res.data.venta, ventaOnlineInsumo: !!res.data.ventaOnline });
            datosInsumo = res.data;
            res.data?.relacionesAutomaticas?.forEach((value, index) => {
              this.onChangeCodigoRelacionesAutomaticasLista(value.codigoSatId, index);
            })
            this.formRef.current.setFieldsValue({
              ...res.data,
              precios: preciosConfig.map((precioC) => {
                let precioA = res.data.precios.find(
                  (valueA) =>
                    valueA.precioId?.toString() === precioC.precioId.toString()
                );
                if (precioA) {
                  let porcentaje = precioA.porcentaje;
                  if (!porcentaje && precioA.precio && res.data.costo) {
                    if (calcularPreciosSobre) {
                      porcentaje = parseFloat(((precioA.precio / res.data.costo - 1) * 100).toFixed(2));
                    } else {
                      porcentaje = parseFloat(((1 - res.data.costo / precioA.precio) * 100).toFixed(2));
                    }
                  }
                  porcentaje = this.clampPorcentaje(porcentaje);
                  return {
                    ...precioA,
                    porcentaje,
                    porcentajeFijo: this.clampPorcentaje(precioA.porcentajeFijo ? precioA.porcentajeFijo : porcentaje),
                  };
                } else {
                  return { ...precioC, porcentajeFijo: this.clampPorcentaje(precioC.porcentajeFijo ? precioC.porcentajeFijo : precioC.porcentaje) };
                }
              }),
              equivalencias: this.mapearEquivalencias(
                res.data.equivalencias,
                preciosConfig,
                res.data.costo,
                calcularPreciosSobre
              ),
              relaciones: this.mapearRelaciones(res.data.relaciones),
              insumosRelacionados: res.data.insumosRelacionados || [],
              fechaCalculo: moment(res.data.fechaCalculo),
            });
            this.setState({ datosCategoriasIniciales: res.data.datosCategorias || [] });
            this.onChangeFamlia(res.data.familiaId);
            

            const principal = this.mapArchivosConConteo(res.data.archivosPrincipal);
            const tecnica   = this.mapArchivosConConteo(res.data.archivosTecnica);
            const fotos     = this.mapArchivosConConteo(res.data.archivosFotos);

            this.setState({
              archivosPrincipal: principal.files,
              archivosTecnica: tecnica.files,
              archivosFotos: fotos.files,
            });
            
            const totalArchivos =
              principal.total +
              tecnica.total +
              fotos.total;

            const totalCargados =
              principal.cargados +
              tecnica.cargados +
              fotos.cargados;

            const totalFallidos =
              principal.fallidos +
              tecnica.fallidos +
              fotos.fallidos;

            if (totalFallidos > 0) {
              message.warning(
                `Carga incompleta de archivos: ${totalCargados}/${totalArchivos}. `
              );
            }


            this.setState({ 
              insumoURREA: res.data.insumoURREA, 
              codigoURREA: res.data.codigoURREA, 
              utilizado: res.data.utilizado,
              fechaCreacion: res.data.createdAt,
              equivalenciasOcultas: this.mapearEquivalencias(
                res.data.equivalenciasOcultas,
                preciosConfig,
                res.data.costo,
                calcularPreciosSobre
              ),
              inventariable: res.data.inventariable,
              historialCostos : res.data.historialCostos,
              ubicacionesPredeterminadas: res.data.ubicacionesPredeterminadas || [],
            });
            this.formRef.current.setFieldsValue({
              codigoProducto: res.data.codigoURREA,
            });
          }
        });
      await axios
        .post(
          "codigoinsumos/buscarCodigoLista",
          { empresaId: this.props.empresaId, subClaseId: datosInsumo.codigoSatId },
          { headers: this.props.headersToken, }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({
              todasCodigoSat: res.data,
              buscarInfoCode: false,
              objetoCodigoSat: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.c_ClaveProdServ + " - " + value.descripcion}
                  </Option>

                );
              }),
            });
          }
        })

    }
    this.setState({ loading: false });
  }

  mapArchivosConConteo = (arr = []) => {
    const total = Array.isArray(arr) ? arr.length : 0;

    const files = (arr || [])
      .map(e => this.recuperarArchivo(e))
      .filter(Boolean);

    const cargados = files.length;
    const fallidos = total - cargados;

    return { files, total, cargados, fallidos };
  };

  async consultarEnvio() {
    this.setState({ loadingEnvios: true });
    await axios
      .post(
        "insumos/selectDatosParaInsumoEnvio",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState(
            {
              loadingEnvios: false,
              todasMaterialesPeligrosos: res.data.materialesPeligrosos,
              todasEmbalajes: res.data.embalajes,
              unidadPeso: res.data.unidadPeso,
              todasSectoresCOF: res.data.sectoresCOF,
              todasFormasFarmaceuticas: res.data.formasFarmaceuticas,
              todasCondicionesEspeciales: res.data.condicionesEspeciales,
              todasTiposMaterias: res.data.tiposMaterias,
              objetoMaterialesPeligrosos: res.data.materialesPeligrosos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoEmbalajes: res.data.embalajes.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoSectoresCOF: res.data.sectoresCOF.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoFormasFarmaceuticas: res.data.formasFarmaceuticas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoCondicionesEspeciales: res.data.condicionesEspeciales.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
              objetoTiposMaterias: res.data.tiposMaterias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              }),
            }
          );
        }
      });
  }


  toggleSeleccionarRelacion(arrayKey) {
    this.setState((prev) => {
      const set = new Set(prev.relacionesSeleccionadas);
      set.has(arrayKey) ? set.delete(arrayKey) : set.add(arrayKey);
      return { relacionesSeleccionadas: [...set] };
    });
  }

  async eliminarRelacionesSeleccionadas() {
    const { relacionesSeleccionadas, id } = this.state;
    const relaciones = this.formRef.current.getFieldValue("relaciones");
    const relacionIds = relacionesSeleccionadas
      .map((idx) => relaciones[idx]?._id)
      .filter(Boolean);
    if (!relacionIds.length) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/cancelarRelacionesInsumo",
        { insumoId: id, relacionIds, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const selectedSet = new Set(relacionesSeleccionadas);
        const remaining = relaciones.filter((_, idx) => !selectedSet.has(idx));
        this.formRef.current.setFieldsValue({ relaciones: remaining });
        this.setState({ relacionesSeleccionadas: [] });
        message.success("Relaciones eliminadas");
      } else {
        message.error(res.data.message || "Error al eliminar");
      }
    } catch {
      message.error("Error al eliminar relaciones");
    } finally {
      this.setState({ loading: false });
    }
  }

  async eliminarTodasRelaciones() {
    const { id } = this.state;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/cancelarTodasRelacionesInsumo",
        { insumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.formRef.current.setFieldsValue({ relaciones: [] });
        this.setState({ relacionesSeleccionadas: [] });
        message.success("Todas las relaciones eliminadas");
      } else {
        message.error(res.data.message || "Error al eliminar");
      }
    } catch {
      message.error("Error al eliminar relaciones");
    } finally {
      this.setState({ loading: false });
    }
  }

  // El % Real (o el % Fijo copiado de el) puede salir negativo cuando el precio guardado
  // quedo por debajo del costo vigente (p. ej. subio el costo y nadie recalculo los precios).
  // Se recorta a 0 en cuanto se calcula, tanto al cargar el insumo como al capturar.
  clampPorcentaje(valor) {
    if (valor === undefined || valor === null || valor === "") return valor;
    const num = typeof valor === "number" ? valor : parseFloat(valor);
    if (isNaN(num)) return valor;
    return num < 0 ? 0 : num;
  }

  // Junta, para el aviso previo a guardar, cada lista de precio (normal o de una equivalencia)
  // cuyo % Fijo o % Real haya quedado en 0.
  obtenerListasPrecioEnCero(values) {
    const avisos = [];
    const nombreLista = (idx) => this.state.precios?.[idx]?.nombre || `Precio ${idx + 1}`;

    (values.precios || []).forEach((precio, idx) => {
      const nombre = nombreLista(idx);
      if (precio?.porcentajeFijo === 0) avisos.push(`${nombre} - % Fijo`);
      if (precio?.porcentaje === 0) avisos.push(`${nombre} - % Real`);
    });

    (values.equivalencias || []).forEach((equivalencia) => {
      const nombreEquiv = equivalencia?.descripcion || "Equivalencia";
      (equivalencia.precios || []).forEach((precio, idx) => {
        const nombre = `${nombreEquiv} / ${nombreLista(idx)}`;
        if (precio?.porcentajeFijo === 0) avisos.push(`${nombre} - % Fijo`);
        if (precio?.porcentaje === 0) avisos.push(`${nombre} - % Real`);
      });
    });

    return avisos;
  }

  // Normaliza los precios de cada equivalencia contra la configuracion vigente de listas.
  // Se aplica igual a las activas y a las ocultas, para que restaurar una la meta al
  // formulario ya con la misma forma que las demas.
  mapearEquivalencias(equivalencias, preciosConfig, costo, calcularPreciosSobre) {
    return (equivalencias || []).map((valueEquiv) => {
      const preciosEquiv = preciosConfig.map((precioC) => {
        const precioA = (valueEquiv.precios || []).find(
          (valueA) => valueA.precioId?.toString() === precioC.precioId.toString()
        );
        if (!precioA) {
          return {
            ...precioC,
            porcentajeFijo: precioC.porcentajeFijo ? precioC.porcentajeFijo : precioC.porcentaje,
          };
        }
        let porcentaje = precioA.porcentaje;
        if (!porcentaje && precioA.precio && costo && valueEquiv.equivalencia) {
          const costoEquiv = costo / valueEquiv.equivalencia;
          if (calcularPreciosSobre) {
            porcentaje = parseFloat(((precioA.precio / costoEquiv - 1) * 100).toFixed(2));
          } else {
            porcentaje = parseFloat(((1 - costoEquiv / precioA.precio) * 100).toFixed(2));
          }
        }
        porcentaje = this.clampPorcentaje(porcentaje);
        return {
          ...precioA,
          porcentaje,
          porcentajeFijo: this.clampPorcentaje(precioA.porcentajeFijo ? precioA.porcentajeFijo : porcentaje),
        };
      });
      return { ...valueEquiv, precios: preciosEquiv };
    });
  }

  // Mete de vuelta la equivalencia al Form.List con estado 1. El backend, al guardar, ve que
  // el _id SI vino en el payload y gana la version enviada, asi que deja de estar oculta.
  restaurarEquivalencia(oculta) {
    const actuales = this.formRef.current.getFieldValue("equivalencias") || [];
    // Arreglo nuevo a proposito: reusar la misma referencia no notifica al Form.List.
    this.formRef.current.setFieldsValue({
      equivalencias: [...actuales, { ...oculta, estado: 1 }],
    });
    this.setState({
      equivalenciasOcultas: this.state.equivalenciasOcultas.filter(
        (valueE) => String(valueE._id) !== String(oculta._id)
      ),
    });
  }

  mapearRelaciones(relaciones) {
    return (relaciones || []).map((valueRelacion) => ({
      ...valueRelacion,
      codigo: valueRelacion.codigo === 'undefined' ? 'Sin codigo' : valueRelacion.codigo,
      costo: valueRelacion.costo ? valueRelacion.costo : 0,
      costoUnitario: valueRelacion.costo && valueRelacion.conversion ? (valueRelacion.costo / valueRelacion.conversion) : 0,
    }));
  }

  abrirAsignarProveedor() {
    this.setState({ modalAsignarProveedor: true });
  }

  cerrarAsignarProveedor(nuevoInsumo) {
    this.setState({ modalAsignarProveedor: false });
    if (nuevoInsumo) {
      this.formRef.current.setFieldsValue({ relaciones: this.mapearRelaciones(nuevoInsumo.relaciones) });
    }
  }

  abrirAgregarControlLogistica() {
    this.setState({ modalAgregarControlLogistica: true });
  }

  cerrarAgregarControlLogistica(nuevaFila) {
    this.setState({ modalAgregarControlLogistica: false });
    if (nuevaFila) {
      this.setState({ controlesFilas: [...this.state.controlesFilas, nuevaFila] });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  agregarFilaUbicacionPredeterminada = () => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: [...prevState.ubicacionesPredeterminadas, { proyectoId: undefined, ubicacionId: undefined }],
    }));
  };

  actualizarProyectoUbicacionPredeterminada = (index, proyectoId) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.map((u, i) =>
        i === index ? { proyectoId, ubicacionId: undefined } : u
      ),
    }));
  };

  actualizarUbicacionEnFilaPredeterminada = (index, ubicacionId) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.map((u, i) =>
        i === index ? { ...u, ubicacionId } : u
      ),
    }));
  };

  eliminarFilaUbicacionPredeterminada = (index) => {
    this.setState((prevState) => ({
      ubicacionesPredeterminadas: prevState.ubicacionesPredeterminadas.filter((_, i) => i !== index),
    }));
  };

  onFinish(values) {
    if (this.state.loadingCategorias) {
      message.warning(
        "Las categorías del insumo aún se están cargando, espera un momento e intenta guardar de nuevo."
      );
      return;
    }

    const listasEnCero = this.obtenerListasPrecioEnCero(values);
    if (listasEnCero.length > 0) {
      Modal.confirm({
        title: "Hay listas de precio en 0%",
        content: (
          <div>
            <p>Las siguientes listas quedaron con % Fijo o % Real en 0:</p>
            <ul>
              {listasEnCero.map((aviso, index) => (
                <li key={index}>{aviso}</li>
              ))}
            </ul>
            <p>¿Deseas guardar el insumo de todos modos?</p>
          </div>
        ),
        okText: "Guardar de todos modos",
        cancelText: "Cancelar",
        onOk: () => this.guardarInsumo(values),
      });
      return;
    }

    this.guardarInsumo(values);
  }

  guardarInsumo(values) {
    this.setState({ loading: true });
    // El tab de Categorias solo se monta cuando se abre, asi que si nunca se abrio sus
    // FormItem no existen y values.datosCategoriasMap llega vacio. En ese caso hay que
    // reenviar los datosCategorias originales tal cual: editarInsumo hace
    // `datosCategorias: req.body.datosCategorias ? JSON.parse(...) : []`, o sea que mandar
    // vacio borraria las categorias del insumo.
    const datosCategorias = this.state.categoriasCargadas
      ? Object.entries(values.datosCategoriasMap || {})
        .filter(([, valorId]) => !!valorId)
        .map(([catId, valorId]) => ({
          categoriaInsumoId: catId,
          valorCategoriaInsumoId: valorId,
        }))
      : (this.state.datosCategoriasIniciales || []).map((d) => ({
        categoriaInsumoId: d.categoriaInsumoId,
        valorCategoriaInsumoId: d.valorCategoriaInsumoId,
      }));
    delete values.datosCategoriasMap;

    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    fd.append("insumoId", this.state.id);
    fd.append("utilizado", !!this.state.utilizado);
    fd.append("datosCategorias", JSON.stringify(datosCategorias));
    const ubicacionesPredeterminadasAGuardar = this.state.ubicacionesPredeterminadas.filter(
      (u) => u.proyectoId && u.ubicacionId
    );
    fd.append("ubicacionesPredeterminadas", JSON.stringify(ubicacionesPredeterminadasAGuardar));
    for (var key in values) {
      if (values[key] === undefined || values[key] === "") {
      } else {
        if (key === "precios") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "equivalencias") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "conversiones") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "impuestos") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "retenciones") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "relaciones") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === 'formasUtilizar') {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "insumosRelacionados") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "relacionesAutomaticas") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "proyectos") {
          fd.append(key, JSON.stringify(values[key]));
        } else {
          if (values[key] !== null) {
            fd.append(key, values[key]);
          }
        }
      }
    }
    this.state.archivosPrincipal.forEach((element, index) => {
      let nombre = "archivoPrincipal" + (index + 1);
      if (element.path) nombre = "archivoPrincipal:" + element.path;
      fd.append(nombre, element.originFileObj || element);
    });
    this.state.archivosTecnica.forEach((element, index) => {
      let nombre = "archivoTecnica" + (index + 1);
      if (element.path) nombre = "archivoTecnica:" + element.path;
      fd.append(nombre, element.originFileObj || element);
    });
    this.state.archivosFotos.forEach((element, index) => {
      let nombre = "archivoFoto" + (index + 1);
      if (element.path) nombre = "archivoFoto:" + element.path;
      fd.append(nombre, element.originFileObj || element);
    });
    
    const esUrlExterna = (f) =>
      typeof f.url === "string" &&
      (f.url.startsWith("http://") || f.url.startsWith("https://"));
    const urlsExternasPrincipal = this.state.archivosPrincipal
      .filter(esUrlExterna)
      .map(f => f.url);
    const urlsExternasTecnica = this.state.archivosTecnica
      .filter(esUrlExterna)
      .map(f => f.url);
    const urlsExternasFotos = this.state.archivosFotos
      .filter(esUrlExterna)
      .map(f => f.url);

    fd.append("urlsPrincipal", JSON.stringify(urlsExternasPrincipal));
    fd.append("urlsTecnica", JSON.stringify(urlsExternasTecnica));
    fd.append("urlsFotos", JSON.stringify(urlsExternasFotos));

    fd.append("productoURREA", this.formRef.current.getFieldValue("insumoURREA"));
    fd.append("codigoURREA", this.state.codigoURREA);
    
    if (this.props?.location?.state?.activo) {
      fd.append("activo", true)
    }
    axios
      .post("insumos/editarInsumo", fd, {
        headers: {
          ...this.props.headersToken,
        },
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado un insumo");
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
          this.setState({
            archivosPrincipal: [],
            archivosTecnica: [],
            archivosFotos: [],
          });
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede editar el insumo");
        } else {
          message.error(res.data.message || "Hubo un error y el insumo no se edito");
        }
      });
  }

  onBlurDescripcion() {
    if (!this.formRef.current.getFieldValue("descripcionLarga")) {
      let value = this.formRef.current.getFieldValue("descripcion");
      this.formRef.current.setFieldsValue({
        descripcionLarga: value,
      });
    }
  }

  async customRequestFicha(e) {
    const file = e.file;
    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };
    this.setState({ archivosTecnica: [...this.state.archivosTecnica, fileObj] });
    e.onSuccess("ok");
  }

  onRemoveFileFicha(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosTecnica");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosTecnica.indexOf(e);
    let nuevoArray = this.state.archivosTecnica;
    nuevoArray.splice(index, 1);
    this.setState({ archivosTecnica: nuevoArray });
  }

  async customRequestPrincipal(e) {
    const file = e.file;
    const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isImage) {
      message.error(`${file.name} no es un tipo de imagen válido`);
      e.onError('Tipo de archivo inválido');
      return;
    }

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }

    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };

    this.setState({
      archivosPrincipal: [...this.state.archivosPrincipal, fileObj],
    });

    e.onSuccess("ok");
  }

  onRemoveFilePrincipal(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosPrincipal");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosPrincipal.indexOf(e);
    let nuevoArray = this.state.archivosPrincipal;
    nuevoArray.splice(index, 1);
    this.setState({ archivosPrincipal: nuevoArray });
  }

  async customRequestFotos(e) {
    const file = e.file;
    const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isImage) {
      message.error(`${file.name} no es un tipo de imagen válido`);
      e.onError('Tipo de archivo inválido');
      return;
    }

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }

    const preview = await getBase64(file);
    const fileObj = {
      uid: file.uid || `${Date.now()}`,
      name: file.name,
      status: 'done',
      preview: preview,
      thumbUrl: preview,
      originFileObj: file,
    };

    this.setState({
      archivosFotos: [...this.state.archivosFotos, fileObj],
    });

    e.onSuccess("ok");
  }

  onRemoveFileFotos(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosFotos");
      fd.append("archivo", e);
      fd.append("path", e.path);
      
    }
    let index = this.state.archivosFotos.indexOf(e);
    let nuevoArray = this.state.archivosFotos;
    nuevoArray.splice(index, 1);
    this.setState({ archivosFotos: nuevoArray });
  }
  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }
  cerrarAgregarUnidad(codigo) {
    this.setState({ modalAgregarUnidad: false });
    this.consultarTodo(true).then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ unidadId: codigo });
      }
    });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia(codigo) {
    this.setState({ modalAgregarFamilia: false });
    this.consultarTodo(true).then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ familiaId: codigo });
      }
    });
  }
  // Misma formula que el input de precio de cada lista (precio -> % Real).
  porcentajeDesdePrecio(precio, base) {
    const valor = Number(precio);
    const calculado = this.state.calcularPreciosSobre
      ? ((valor - base) / base) * 100
      : ((valor - base) / valor) * 100;
    return this.clampPorcentaje(calculado).toFixed(2);
  }
  onChangeCosto() {
    const valueCosto = this.formRef.current.getFieldValue("costo");
    if (!valueCosto) return;
    // Con la opcion de la empresa el precio que ya existe no se toca: solo se
    // ajusta su % Real al costo nuevo. Un renglon sin precio se sigue llenando.
    const conservarPrecios = !!this.state.noRecalcularPreciosAlEditarCosto;
    let arrayValues = this.formRef.current.getFieldValue("precios");
    let equivalencias = this.formRef.current.getFieldValue("equivalencias");
    let arrayNuevo = arrayValues.map((value, index) => {
      if (conservarPrecios && Number(value.precio) > 0) {
        return { ...value, porcentaje: this.porcentajeDesdePrecio(value.precio, valueCosto) };
      }
      let precio;
      if (this.state.calcularPreciosSobre) {
        precio = ((valueCosto * (100 + value.porcentaje)) / 100).toFixed(2);
      } else {
        precio = (valueCosto / ((100 - value.porcentaje) / 100)).toFixed(2);
      }
      return { ...value, precio };
    });
    let equivalenciasNuevas;
    if (!equivalencias) {
      equivalenciasNuevas = equivalencias;
    } else {
      equivalenciasNuevas = equivalencias.map((valueE, index) => {
        let arrayPrecios = valueE.precios;
        if (!valueE.equivalencia) return { ...valueE };
        if (!arrayPrecios) return { ...valueE };
        let arrayNuevoPrecios = arrayPrecios.map((valueP, index) => {
          if (conservarPrecios && Number(valueP.precio) > 0) {
            return {
              ...valueP,
              porcentaje: this.porcentajeDesdePrecio(valueP.precio, valueCosto / valueE.equivalencia),
            };
          }
          let precio;
          if (this.state.calcularPreciosSobre) {
            precio = (
              ((valueCosto / valueE.equivalencia) * (100 + valueP.porcentaje)) /
              100
            ).toFixed(2);
          } else {
            precio = (
              valueCosto /
              valueE.equivalencia /
              ((100 - valueP.porcentaje) / 100)
            ).toFixed(2);
          }
          return { ...valueP, precio };
        });
        return { ...valueE, precios: arrayNuevoPrecios };
      });
    }
    this.formRef.current.setFieldsValue({
      precios: arrayNuevo,
      equivalencias: equivalenciasNuevas,
    });
  }
  handleCancel = () => this.setState({ previewVisible: false });
  handlePreview = async (file) => {
    let preview;

    if (file.url) {
      // Si es una URL externa, usamos directamente la URL
      preview = file.url;
    } else if (file.preview) {
      // Si ya tiene preview base64, usamos eso
      preview = file.preview;
    } else {
      // Si es un archivo subido desde input, generamos base64
      preview = await getBase64(file.originFileObj || file);
      file.preview = preview;
    }

    this.setState({
      previewImage: preview,
      previewVisible: true,
      previewTitle:
        file.name || (file.url ? file.url.substring(file.url.lastIndexOf("/") + 1) : ""),
      previewFile: file,
    });
  };

  onChangeImpuesto() {
    const impuestos = this.formRef.current.getFieldValue("impuestos");
    let combustible = false;
    let impuestoIdCombustible;
    impuestos.map((valueImpuesto) => {
      if (valueImpuesto?.impuestoId) {
        const impuesto = this.state.todasImpuestos.find(
          (valueTodasImpuesto) =>
            valueTodasImpuesto._id.toString() ===
            valueImpuesto.impuestoId.toString()
        );
        if (impuesto.combustible) {
          combustible = true;
          impuestoIdCombustible = impuesto._id;
        }
      }
      return null;
    });
    if (combustible) {
      message.info(
        "Si el impuesto es especial solamente se puede elegir uno y no se puede vender"
      );
      this.setState({ impuestoCombustible: combustible });
      this.formRef.current.setFieldsValue({
        impuestos: [{ impuestoId: impuestoIdCombustible }],
        venta: false,
      });
    } else {
      this.setState({ impuestoCombustible: combustible });
    }
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  onChangeFamlia(familiaId) {
    const familia = this.state.todasFamilia.find(
      (valueTodasFamilia) =>
        valueTodasFamilia._id.toString() === familiaId.toString()
    );
    if (familia.gastoNoDeducible) {
      message.info(
        "Si la familia es gasto no deducible no se puede inventariar ni vender"
      );
      this.setState({ familiaGastoNoDeducible: true });
      this.formRef.current.setFieldsValue({ inventariable: false, venta: false, flete: false })
    } else {
      this.setState({ familiaGastoNoDeducible: false });
    }
    // Solo se recargan las categorias si el usuario ya abrio el tab. Si nunca lo abrio no
    // se pide nada, y al guardar se reenvian los datosCategorias originales (ver onFinish).
    if (this.state.categoriasCargadas) {
      this.setState({ categoriasCargadas: false, familiaCategoriasCargada: null }, () =>
        this.cargarCategoriasDeTab(familiaId)
      );
    }
  }

  // Trae categorias hoja + principales + TODOS sus valores en una sola request y aplica un
  // unico setState. Antes eran 2 requests + una por cada categoria, y como React 17 no
  // batchea setState dentro de promesas, cada respuesta forzaba un re-render completo de
  // este formulario.
  cargarCategoriasDeTab = (familiaIdParam) => {
    const familiaId =
      familiaIdParam || this.formRef.current?.getFieldValue("familiaId");
    if (!familiaId) {
      this.setState({
        valoresPorCategoria: {},
        gruposCategorias: { grupos: [], sueltas: [] },
        loadingCategorias: false,
      });
      return;
    }
    if (
      this.state.loadingCategorias ||
      (this.state.categoriasCargadas &&
        this.state.familiaCategoriasCargada === familiaId.toString())
    ) {
      return;
    }
    this.setState({ loadingCategorias: true });
    axios
      .post(
        "categoriasInsumo/datosCategoriasParaFamilia",
        { empresaId: this.props.empresaId, familiaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loadingCategorias: false });
          return;
        }
        const categorias = res.data.categorias || [];
        const principalesMap = {};
        (res.data.principales || []).forEach((p) => {
          principalesMap[p._id.toString()] = p.nombre;
        });
        this.setState(
          {
            valoresPorCategoria: res.data.valores || {},
            gruposCategorias: agruparCategorias(categorias, principalesMap),
            categoriasCargadas: true,
            familiaCategoriasCargada: familiaId.toString(),
            loadingCategorias: false,
          },
          this.hidratarDatosCategoriasMap
        );
      })
      .catch((err) => {
        console.error("Error al consultar categorías:", err);
        this.setState({ loadingCategorias: false });
      });
  }

  // Solo se usa para refrescar un select puntual despues de agregar un valor nuevo desde
  // el modal; la carga inicial va por cargarCategoriasDeTab.
  consultarValoresCategoria = (categoriaInsumoId) => {
    return axios
      .post(
        "valoresCategoriaInsumo/selectValoresPorCategoria",
        { categoriaInsumoId, valor: 1 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState((prev) => ({
            valoresPorCategoria: {
              ...prev.valoresPorCategoria,
              [categoriaInsumoId]: res.data.valores || [],
            },
          }));
        }
      })
      .catch((err) => console.error("Error al consultar valores:", err));
  }

  hidratarDatosCategoriasMap = () => {
    const { datosCategoriasIniciales } = this.state;
    if (!datosCategoriasIniciales || !this.formRef.current) return;
    const datosCategoriasMap = {};
    datosCategoriasIniciales.forEach((d) => {
      datosCategoriasMap[d.categoriaInsumoId] = d.valorCategoriaInsumoId;
    });
    this.formRef.current.setFieldsValue({ datosCategoriasMap });
  }

  async consultarExistencias() {
    await this.setState({ loadingExistencias: true })
    await axios
      .post(
        "insumos/datosExistencias",
        { empresaId: this.props.empresaId, insumoId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingExistencias: false,
            existencias: res.data.existencias,
            equivalenciasExistencias: res.data.equivalencias || [],
          })
        } else {
          this.setState({ loadingExistencias: false })
          message.warning('No se pudo cargar los datos de existencias')
        }
      });
  }

  formatoCantidadExistencia(valor) {
    return round10Decimals(Number(valor) || 0).toLocaleString(undefined, {
      maximumFractionDigits: 4,
    });
  }

  async consultarKardex(proyectoId) {
    const pid = proyectoId !== undefined ? proyectoId : this.state.proyectoKardex;
    this.setState({ loadingKardex: true });
    if (!this.state.kardexCargado) {
      const resProyectos = await axios.post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (resProyectos.data && resProyectos.data.status !== 404) {
        this.setState({
          todasProyectosKardex: resProyectos.data,
          objetoProyectosKardex: resProyectos.data.map((v) => (
            <Option value={v._id} key={v._id}>{v.nombre}</Option>
          )),
        });
      }
    }
    await axios
      .post(
        "inventarios/selectEntradasSalidasProducto",
        { empresaId: this.props.empresaId, insumoId: this.state.id, proyectoId: pid },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          kardex: res.data.status === 404 ? [] : res.data,
          loadingKardex: false,
          proyectoKardex: pid,
          kardexCargado: true,
        });
      });
  }

  async consultarProyecciones() {
    this.setState({ loadingProyecciones: true });
    await axios
      .post(
        "insumos/datosProyecciones",
        { empresaId: this.props.empresaId, insumoId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ loadingProyecciones: false, proyecciones: res.data });
        } else {
          this.setState({ loadingProyecciones: false });
          message.warning('No se pudo cargar los datos de proyecciones');
        }
      });
  }

  async consultarLogistica() {
    await this.setState({ loadingLogistica: true })
    await axios
      .post(
        "insumos/datosLogistica",
        { empresaId: this.props.empresaId, insumoId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.info('Los calculos son hechos con informacion de un año hacia atras')
          this.setState({
            loadingLogistica: false,
            ventasPProyecto: res.data.ventasPProyecto,
            entregasPProveedor: res.data.entregasPProveedor,
            controlesPropuestos: res.data.controlesPropuestos,
            controlesDadosDeAlta: res.data.controlesDadosDeAlta,
            controlesFilas: this.construirControlesFilas(res.data.controlesPropuestos, res.data.controlesDadosDeAlta),
            tiempoEntregaManualDias: res.data.tiempoEntregaManualDias,
          })
        } else {
          this.setState({ loadingLogistica: false })
          message.warning('No se pudo cargar los datos logisticos')
        }
      });
  }

  construirControlesFilas(controlesPropuestos, controlesDadosDeAlta) {
    const filasPorProyecto = new Map();

    controlesPropuestos.forEach((valuePropuesto) => {
      const key = valuePropuesto.proyectoId ? valuePropuesto.proyectoId.toString() : 'general';
      filasPorProyecto.set(key, {
        proyectoId: valuePropuesto.proyectoId,
        proyectoNombre: valuePropuesto.proyectoNombre,
        minPropuesto: valuePropuesto.minPropuesto,
        maxPropuesto: valuePropuesto.maxPropuesto,
        controlId: null,
        min: null,
        max: null,
        guardando: false,
      });
    });

    controlesDadosDeAlta.forEach((valueControl) => {
      const key = valueControl.proyectoId ? valueControl.proyectoId.toString() : 'general';
      const filaExistente = filasPorProyecto.get(key);
      if (filaExistente) {
        filaExistente.controlId = valueControl.controlId;
        filaExistente.min = valueControl.min;
        filaExistente.max = valueControl.max;
      } else {
        filasPorProyecto.set(key, {
          proyectoId: valueControl.proyectoId,
          proyectoNombre: valueControl.proyectoNombre,
          minPropuesto: null,
          maxPropuesto: null,
          controlId: valueControl.controlId,
          min: valueControl.min,
          max: valueControl.max,
          guardando: false,
        });
      }
    });

    return Array.from(filasPorProyecto.values());
  }

  controlDifiereDePropuesto(fila, campo) {
    const propuesto = campo === 'min' ? fila.minPropuesto : fila.maxPropuesto;
    const actual = campo === 'min' ? fila.min : fila.max;
    if (propuesto === null || propuesto === undefined) return false;
    if (actual === null || actual === undefined) return true;
    return Number(actual) !== Number(propuesto);
  }

  actualizarValorControlFila(index, campo, valor) {
    const controlesFilas = [...this.state.controlesFilas];
    controlesFilas[index] = { ...controlesFilas[index], [campo]: valor };
    this.setState({ controlesFilas });
  }

  aplicarSugerido(index) {
    const controlesFilas = [...this.state.controlesFilas];
    const fila = controlesFilas[index];
    controlesFilas[index] = { ...fila, min: fila.minPropuesto, max: fila.maxPropuesto };
    this.setState({ controlesFilas });
  }

  async guardarControlFila(index) {
    const fila = this.state.controlesFilas[index];
    if (fila.min === null || fila.min === undefined || fila.max === null || fila.max === undefined) {
      message.error('Captura Min y Max antes de guardar');
      return;
    }
    if (Number(fila.min) > Number(fila.max)) {
      message.error('Min debe ser menor o igual a Max');
      return;
    }

    let controlesFilas = [...this.state.controlesFilas];
    controlesFilas[index] = { ...fila, guardando: true };
    this.setState({ controlesFilas });

    await axios
      .post(
        'controlInventario/guardarControlDesdeLogistica',
        {
          empresaId: this.props.empresaId,
          insumoId: this.state.id,
          proyectoId: fila.proyectoId,
          min: fila.min,
          max: fila.max,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        controlesFilas = [...this.state.controlesFilas];
        if (res.data.success === 2) {
          controlesFilas[index] = { ...controlesFilas[index], controlId: res.data.controlId, guardando: false };
          message.success('Control guardado');
        } else {
          controlesFilas[index] = { ...controlesFilas[index], guardando: false };
          message.error(res.data.message || 'No se pudo guardar el control');
        }
        this.setState({ controlesFilas });
      });
  }

  async guardarTiempoEntregaManual() {
    this.setState({ guardandoTiempoEntregaManual: true });
    await axios
      .post(
        'insumos/editarTiempoEntregaManual',
        {
          empresaId: this.props.empresaId,
          insumoId: this.state.id,
          tiempoEntregaManualDias: this.state.tiempoEntregaManualDias,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardandoTiempoEntregaManual: false });
        if (res.data.success === 2) {
          message.success('Tiempo de entrega manual actualizado');
          this.consultarLogistica();
        } else {
          message.error(res.data.message || 'No se pudo guardar el tiempo de entrega manual');
        }
      });
  }

  onChangeCodigo(value, { autoSelect = false } = {}) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    this.setState({ buscarInfoCode: true })
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasCodigoSat: res.data,
            buscarInfoCode: false,
            objetoCodigoSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_ClaveProdServ + " - " + value.descripcion}
                </Option>

              );
            }),
          });

          if (autoSelect) {
            this.formRef.current?.setFieldsValue({
              codigoSatId: res.data[0]._id,
            });
          }
        }
      })
  }


  onChangeVenta(e) {
    this.setState({ venta: e });
    if (!e) {
      this.formRef.current?.setFieldsValue({ ventaOnline: false });
      this.setState({ ventaOnlineInsumo: false });
    }
    if (e) {
      if (!this.state.objetoCodigoSat) {
        this.setState({ buscarInfoCode: true })
        axios
          .post(
            "codigoinsumos/buscarCodigoLista",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken, }
          )
          .then((res) => {
            if (res.data.status === 404) {
            } else {
              this.setState({
                todasCodigoSat: res.data,
                buscarInfoCode: false,
                objetoCodigoSat: res.data.map((value) => {
                  return (
                    <Option value={value._id} key={value._id}>
                      {value.c_ClaveProdServ + " - " + value.descripcion}
                    </Option>

                  );
                }),
              });
            }
          })
      }
    }
  }

  onChangeCodigoRelacionesAutomaticas(value, index) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    let buscarInfoCodeRA = this.state.buscarInfoCodeRA
    buscarInfoCodeRA[index] = true
    this.setState({ buscarInfoCodeRA })
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {

          let objetoCodigoSatRA = this.state.objetoCodigoSatRA
          objetoCodigoSatRA[index] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.c_ClaveProdServ + " - " + value.descripcion}
              </Option>

            );
          })
          let buscarInfoCodeRA = this.state.buscarInfoCodeRA
          buscarInfoCodeRA[index] = false
          let todasCodigoSatRA = this.state.todasCodigoSatRA
          todasCodigoSatRA[index] = res.data

          this.setState({
            todasCodigoSatRA,
            buscarInfoCodeRA,
            objetoCodigoSatRA
          });
        }
      })
  }

  onChangeCodigoRelacionesAutomaticasLista(subClaseId, index) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    let buscarInfoCodeRA = this.state.buscarInfoCodeRA
    buscarInfoCodeRA[index] = true
    this.setState({ buscarInfoCodeRA })
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, subClaseId: subClaseId },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {

          let objetoCodigoSatRA = this.state.objetoCodigoSatRA
          objetoCodigoSatRA[index] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.c_ClaveProdServ + " - " + value.descripcion}
              </Option>

            );
          })
          let buscarInfoCodeRA = this.state.buscarInfoCodeRA
          buscarInfoCodeRA[index] = false
          let todasCodigoSatRA = this.state.todasCodigoSatRA
          todasCodigoSatRA[index] = res.data

          this.setState({
            todasCodigoSatRA,
            buscarInfoCodeRA,
            objetoCodigoSatRA
          });
        }
      })
  }

  onChangeSelectCodigoRelacionesAutomaticas(value, index) {          /*Fragmento que regresa la lista de busqueda del codigo*/
    let buscarInfoCodeRA = this.state.buscarInfoCodeRA
    buscarInfoCodeRA[index] = true
    this.setState({ buscarInfoCodeRA })
    axios
      .post(
        "codigoinsumos/seleccionarCodigoRA",
        { empresaId: this.props.empresaId, codigoSatId: value, insumoId: this.state.id },
        { headers: this.props.headersToken, }
      )
      .then((res) => {
        let buscarInfoCodeRA = this.state.buscarInfoCodeRA
        buscarInfoCodeRA[index] = false

        this.setState({
          buscarInfoCodeRA,
        });
        if (res.data.success !== 2) {
          message.warning(res.data.message ? res.data.message : 'No se puede seleccionar el codigo')

          let relacionesAutomaticas = this.formRef.current.getFieldValue('relacionesAutomaticas')

          relacionesAutomaticas[index].codigoSatId = undefined

          this.formRef.current.setFieldsValue({
            relacionesAutomaticas
          })

        }
      })
  }
  onSearchInsumoURREA = (value) => {
    this.setState({ modalBusquedaURREA: true, codigoURREA: value });
  }
  cerrarModalBusquedaURREA = () => {
    this.setState({ modalBusquedaURREA: false });
    //this.setState(); 
  }
  // Función que recibe el producto de urrea 
  handleConfirmProducto = (producto) => {
    if (producto) {
      if (this.formRef.current) {
        //Buscar unidad SAT
        const unidadSATProducto = producto.unidad;
        const unidadEncontrada = this.state.todasUnidades.find(
          (u) => u.unidadSat?.c_ClaveUnidad === unidadSATProducto
        );
        //Buscar Marca
        const nombreMarcaProducto = producto.marca;
        const marcaEncontrada = this.state.todasMarcas?.find(
          (m) => m.nombre === nombreMarcaProducto
        );
        //Guardar el valor del codigoSat para cuando se busquen cargarlo automaticamente 
        this.formRef.current.setFieldsValue({
          codigoBarras: producto.codigoBarras,
          descripcion: producto.descripcion,
          descripcionLarga: producto.descripcionLarga,
          fotografia: producto.fotografia,
          unidadId: unidadEncontrada?._id || null,
          marcaId: marcaEncontrada?._id || null,

        });
        //Disparar la búsqueda y seleccionar el primer dato coincidente  
        this.onChangeCodigo(producto.anexoSat, { autoSelect: true });

        const url = producto.fotografia;
        // Tomar lo que está después de la última barra
        const nombreArchivo = url.split('/').pop();
        // Creamos un objeto tipo File “simulado”
        const fileFromUrl = {
          uid: `url-${Date.now()}`,    // UID único
          name: nombreArchivo,         // Nombre que quieres mostrar
          status: "done",
          url: url,                    // La URL de la imagen
          size: 0,
          type: "image/jpeg",          // Tipo MIME (ajústalo si no es jpeg)
          originFileObj: null
        };

        // Añadimos al estado
        this.setState({
          archivosPrincipal: [fileFromUrl]
        });
      }
    } else {
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue({
          codigoBarras: "",
          descripcion: "",
          descripcionLarga: "",
        });
      }
    }
    this.setState({ modalVisible: false });
  };

  recuperarArchivo(element) {
    if(!element.nofile){
      if (element.base64 && element.base64 !== null) {
        let mimetype =
          element.extension !== "pdf"
            ? "image/" + element.extension
            : "application/pdf";

        // Convertir base64 a array de bytes
        const byteString = atob(element.base64);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([ia], { type: mimetype });

        const file = new File([blob], element.name, {
          type: blob.type,
          lastModified: new Date(),
        });

        const dataUrl = `data:${mimetype};base64,${element.base64}`;
        return {
          uid: `file-${Date.now()}-${element.name}`,
          name: element.name,
          status: 'done',
          url: dataUrl,
          thumbUrl: dataUrl,
          originFileObj: file,
          path: element.path,
        };
      } else if (element.path.startsWith("http://") || element.path.startsWith("https://")) {
        // Archivo externo: no tiene base64, solo usamos la URL
        return {
          uid: `url-${Date.now()}`,  // UID único para Upload
          name: element.name,
          status: "done",
          url: element.path,
          path: element.path,
          extension: element.extension,
        };
      } else {
        return null;
      }
    }else{
      return null;
    }

  }

  async consultarUsuarios() {
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todosUsuarios: res.data,
          });
        }
      })
      .catch((err) => {
        console.error("Error al cargar usuarios", err);
      });
  }

  /**
   * Arma la data de la pestaña Historial de Costos: la ordena de lo mas reciente a lo mas
   * viejo y le calcula a cada renglon cuanto se movio el costo contra el renglon anterior.
   *
   * La variacion se precalcula AQUI y no en el render de la celda a proposito: si se
   * calculara contra el vecino de la tabla, ordenar o filtrar moveria los vecinos y el
   * delta mentiria. Aqui el "anterior" siempre es el cronologicamente anterior.
   */
  historialCostosOrdenado() {
    const historial = this.state.historialCostos || [];

    const ascendente = [...historial].sort(
      (a, b) => new Date(a.fecha) - new Date(b.fecha)
    );

    const conVariacion = ascendente.map((item, index) => {
      const anterior = index > 0 ? ascendente[index - 1] : null;
      const costoAnterior = anterior ? Number(anterior.costo) : null;
      const costoActual = Number(item.costo);

      let variacion = null;
      if (costoAnterior !== null && !isNaN(costoAnterior) && !isNaN(costoActual)) {
        variacion = {
          monto: costoActual - costoAnterior,
          // Sin porcentaje cuando se partia de cero: dividir entre 0 da Infinity.
          porcentaje: costoAnterior !== 0
            ? ((costoActual - costoAnterior) / Math.abs(costoAnterior)) * 100
            : null,
        };
      }

      let nombreUsuario = "Desconocido";
      if (item.usuarioId && this.state.todosUsuarios) {
        const usuario = this.state.todosUsuarios.find(
          (u) => u._id?.toString() === item.usuarioId?.toString()
        );
        if (usuario) {
          nombreUsuario = `${usuario.nombre} ${usuario.apellidoPaterno || ""} ${usuario.apellidoMaterno || ""}`.trim();
        }
      }

      return {
        ...item,
        // El historial viejo puede no traer _id; TableItem cae a record._id como rowKey.
        _id: item._id || `historial-${index}`,
        variacion,
        nombreUsuario,
        origen: item.origen || "sinRegistro",
      };
    });

    // Lo mas reciente arriba.
    return conVariacion.reverse();
  }

  /** Abre el documento que origino un renglon del historial, sin salir del formulario. */
  abrirDocumentoHistorial(record) {
    if (!record.documentoId) return;
    if (record.documentoTipo === "OrdenDeCompra") {
      this.abrirModalVerOrdenCompra(record.documentoId);
    } else if (record.documentoTipo === "Factura" || record.documentoTipo === "Remision") {
      // Sin pasarle tipoFactura: el modal lo resuelve en el servidor a partir de
      // cajaId / ordenDeCompraId, asi que un solo id cubre factura con OC, sin OC,
      // de caja chica y remision.
      this.abrirModalVerFacturaCompra(record.documentoId);
    }
  }

  abrirModalVerVenta(id) {
    this.setState({
      modalCorreoVenta: true,
      modalCorreoVentaId: id
    });
  }

  cerrarMandarCorreoVenta() {
    this.setState({
      modalCorreoVenta: false,
      modalCorreoVentaId: null
    });
  }

  abrirModalVerOrdenCompra(id) {
    this.setState({
      modalCorreoOrdenCompra: true,
      modalCorreoOrdenCompraId: id
    });
  }

  cerrarModalVerOrdenCompra() {
    this.setState({
      modalCorreoOrdenCompra: false,
      modalCorreoOrdenCompraId: null
    });
  }

  abrirModalVerFacturaCompra(id) {
    this.setState({
      modalCorreoFacturaCompra: true,
      modalCorreoFacturaCompraId: id
    });
  }

  cerrarModalVerFacturaCompra() {
    this.setState({
      modalCorreoFacturaCompra: false,
      modalCorreoFacturaCompraId: null
    });
  }

  abrirEquivModal = (idx) => {
    const equivalencias = this.formRef.current.getFieldValue("equivalencias");
    const currentVal = equivalencias?.[idx]?.equivalencia;
    const newState = { equivModal: { visible: true, idx } };
    if (currentVal && !this.state.equivCalcCantBase[idx]) {
      const presArr = [...this.state.equivCalcCantPres];
      const baseArr = [...this.state.equivCalcCantBase];
      presArr[idx] = 1;
      baseArr[idx] = currentVal;
      newState.equivCalcCantPres = presArr;
      newState.equivCalcCantBase = baseArr;
    }
    this.setState(newState);
  }

  cerrarEquivModal = () => {
    this.setState({ equivModal: { visible: false, idx: null }, equivModalMostrarEjemplos: false });
  }

  switchEquivModalMostrarEjemplos = () => {
    this.setState((prevState) => ({ equivModalMostrarEjemplos: !prevState.equivModalMostrarEjemplos }));
  }

  setEquivCalcCantPres = (idx, val) => {
    const arr = [...this.state.equivCalcCantPres];
    arr[idx] = val;
    this.setState({ equivCalcCantPres: arr }, () => this.recalcularEquivalencia(idx));
  }

  setEquivCalcCantBase = (idx, val) => {
    const arr = [...this.state.equivCalcCantBase];
    arr[idx] = val;
    this.setState({ equivCalcCantBase: arr }, () => this.recalcularEquivalencia(idx));
  }

  recalcularEquivalencia = (idx) => {
    const pres = this.state.equivCalcCantPres[idx] || 0;
    const base = this.state.equivCalcCantBase[idx] || 0;
    if (pres > 0) {
      const equivalencias = this.formRef.current.getFieldValue("equivalencias");
      if (!equivalencias[idx]) return;
      equivalencias[idx].equivalencia = parseFloat((base / pres).toFixed(4));
      this.formRef.current.setFieldsValue({ equivalencias });
      this.onChangeCosto();
    }
  }

  resolverNombreUnidad = (unidadId) => {
    const unidad = this.state.todasUnidades?.find((u) => u._id === unidadId);
    if (!unidad) return "unidad";
    return [unidad.unidadSat?.c_ClaveUnidad, unidad.nombre].filter(Boolean).join(" - ");
  }

  render() {
    const { previewVisible, previewImage, previewTitle, previewFile, relacionesSeleccionadas } = this.state;
    const isMobile = window.innerWidth < 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={this.props?.location?.state?.activo ? "Editar Activo" : "Editar Insumo"}
          subTitle={this.state.fechaCreacion ? "Creado el " + moment(this.state.fechaCreacion).format("DD/MM/YYYY HH:mm") : null}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background" style={{ paddingTop: 15 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarInsumo"
              layout
              bottom={
                <ButtonItem
                  hotkey="shift+a"
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Editar Insumo
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
          <GeneralFormLayout
            cards={[
              {
                title: "DATOS GENERALES",
                lg: 24,
                content: (
                   <>
                   <Row gutter={[16, 8]} justify="start">
                      {/*IZQUIERDA*/}
                      <Col xs={24} lg={17} xl={17} xxl={17}>
                        <Row gutter={[8, 4]}>
                          <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={5}>
                            <FormItem
                                name="fechaCalculo"
                                label="Fecha"
                                margin
                                 labelCol={{ span: 10 }}
                                wrapperCol={{ span: 14 }}
                              >
                                <DatePickerItem
                                  suffixIcon={null}
                                  placeholder="Fecha"
                                  allowClear={false}
                                  disabled
                                  size="small"
                                  style={{ width: '100%' }}
                                />
                            </FormItem>
                             <Row gutter={[8, 0]}>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="Permitir Venta"
                                name="venta"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5 }}
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem
                                  disabled={
                                    this.state.familiaGastoNoDeducible ||
                                    this.state.impuestoCombustible
                                  }
                                  onChange={(e) => this.onChangeVenta(e)}
                                />
                              </FormItem>
                            </Col>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="P. Venta en línea"
                                name="ventaOnline"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5 }}
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem
                                  disabled={this.state.impuestoCombustible || this.state.familiaGastoNoDeducible || !this.state.venta || !this.state.ventaOnline}
                                  onChange={(e) => this.setState({ ventaOnlineInsumo: e })}
                                />
                              </FormItem>
                            </Col>
                            <Col xs={8} sm={24}>
                              <FormItem
                                label="Permitir Compra"
                                name="compra"
                                margin
                                labelCol={{ span: 19}}
                                wrapperCol={{ span: 5}}
                                initialValue={true}
                                valuePropName="checked"
                              >
                                <SwitchItem onChange={(value) => this.setState({ permitirCompra: value })}/>
                              </FormItem>
                            </Col>
                          </Row>
                        </Col>

                          <Col xs={24} sm={12} md={9} lg={10} xl={10} xxl={11}>
                            <FormItem
                              name="codigo"
                              label="Código"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem disabled placeholder="Código" size="small" />
                            </FormItem>
                            <FormItem
                              name="clave"
                              label="Clave"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem placeholder="Clave" size="small" />
                            </FormItem>
                            <FormItem
                              name="codigoProveedor"
                              label="Cód. Prov."
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                            >
                              <InputItem placeholder="Cód. Proveedor" size="small" />
                            </FormItem>
                            <FormItem
                              label="Cód. barras"
                              name="codigoBarras"
                              margin
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 17 }}
                              pattern
                              required={this.state.codBarObligatorio}
                            >
                              <InputItem placeholder="Cód. de barras" size="small" />
                            </FormItem>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
                            <FormItem
                              label="Marca"
                              name="marcaId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                allowClear
                                placeholder="Marca"
                                size="small"
                              >
                                {this.state.objetoMarcas}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Costo"
                              name="costo"
                              required
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                              numberCero
                            >
                              <InputNumberItem
                                placeholder="Costo"
                                dinero
                                size="small"
                                onChange={this.onChangeCosto.bind(this)}
                                disabled={this.props.permisoBloquearEdicionCosto}
                              />
                            </FormItem>
                            <FormItem
                              label="Moneda"
                              name="monedaId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                              initialValue="60c7e4396465ad440c41c15a"
                            >
                              <SelectItem
                                allowClear
                                placeholder="Moneda"
                                size="small"
                              >
                                {this.state.objetoMonedas}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Unidad"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <Input.Group compact>
                                <FormItem name="unidadId" required noStyle>
                                  <SelectItem
                                    placeholder="Unidad"
                                    width="calc(100% - 32px)"
                                    size="small"
                                  >
                                    {this.state.objetoUnidades}
                                  </SelectItem>
                                </FormItem>
                                <ButtonItem
                                  icon={<PlusOutlined />}
                                  size="small"
                                  style={{
                                    width: "28px",
                                    marginLeft: 4,
                                  }}
                                  onClick={this.abrirAgregarUnidad.bind(this)}
                                />
                              </Input.Group>
                            </FormItem>
                          </Col>
                        </Row>

                        <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
                          <Col xs={24}>
                            <FormItem
                              label="Descripción"
                              name="descripcion"
                              required
                              margin
                              labelCol={{ span: 3 }}
                              wrapperCol={{ span: 21 }}
                              pattern
                            >
                              <InputItem
                                placeholder="Descripción"
                                size="small"
                                onBlur={this.onBlurDescripcion.bind(this)}
                              />
                            </FormItem>
                            <FormItem
                              label="Desc. Larga"
                              name="descripcionLarga"
                              required
                              margin
                              labelCol={{ span: 3 }}
                              wrapperCol={{ span: 21 }}
                              pattern
                            >
                              <TextAreaItem
                                placeholder="Descripción larga"
                                rows={2}
                                style={{ resize: 'none' }}
                              />
                            </FormItem>
                            {this.state.ventaOnlineInsumo && (
                              <FormItem
                                label="Desc. Web"
                                name="descripcionWeb"
                                margin
                                labelCol={{ span: 3 }}
                                wrapperCol={{ span: 21 }}
                              >
                                <DescripcionWebEditor />
                              </FormItem>
                            )}
                          </Col>
                        </Row>
                      </Col>

                      {/* DERECHA */}
                      <Col xs={24} lg={7} xl={7} xxl={7}>
                        <Row gutter={[8, 8]}>

                          <Col xs={24} sm={12} lg={24}>
                              <div style={{
                                textAlign: 'center',
                                marginBottom: 8,
                                fontWeight: 600,
                                fontSize: '13px'
                              }}>
                                IMPUESTOS
                              </div>
                              <FormInitial.List name="impuestos">
                                {(fields, { add, remove }) => (
                                  <>
                                    <div style={{ maxHeight: '140px', overflowY: 'auto', paddingRight: '4px' }}>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                          <Col flex="1">
                                            <FormItem
                                              name={[name, "impuestoId"]}
                                              fieldKey={[arrayKey, "impuestoId"]}
                                              required
                                              noStyle
                                            >
                                              <SelectItem
                                                disabled={this.state.utilizado}
                                                width="100%"
                                                placeholder="Impuesto"
                                                size="small"
                                                onChange={this.onChangeImpuesto.bind(this)}
                                              >
                                                {this.state.objetoImpuestos}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col flex="28px">
                                            <div style={{ textAlign: 'center' }}>
                                              {!this.state.utilizado ? (
                                                <DeleteOutlined
                                                  style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                  onClick={() => {
                                                    remove(name);
                                                    this.onChangeImpuesto();
                                                  }}
                                                />
                                              ) : null}
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                    </div>
                                    {!this.state.impuestoCombustible && (
                                      <div style={{ textAlign: 'center', marginTop: 8 }}>
                                        <ButtonItem
                                          type="dashed"
                                          disabled={this.state.utilizado}
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                          size="small"
                                          block
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    )}
                                  </>
                                )}
                              </FormInitial.List>
                          </Col>

                          <Col xs={24} sm={12} lg={24}>
                            <BoxItem style={{ padding: '10px' }}>
                              <div style={{
                                textAlign: 'center',
                                marginBottom: 8,
                                fontWeight: 600,
                                fontSize: '13px'
                              }}>
                                RETENCIONES
                              </div>
                              <FormInitial.List name="retenciones">
                                {(fields, { add, remove }) => (
                                  <>
                                    <div style={{ maxHeight: '140px', overflowY: 'auto', paddingRight: '4px' }}>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                          <Col flex="1">
                                            <FormItem
                                              name={[name, "retencionId"]}
                                              fieldKey={[arrayKey, "retencionId"]}
                                              required
                                              noStyle
                                            >
                                              <SelectItem
                                                width="100%"
                                                placeholder="Retención"
                                                size="small"
                                              >
                                                {this.state.objetoRetenciones}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col flex="28px">
                                            <div style={{ textAlign: 'center' }}>
                                              <DeleteOutlined
                                                style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '16px' }}
                                                onClick={() => remove(name)}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                    </div>
                                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                                      <ButtonItem
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        size="small"
                                        block
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </BoxItem>
                          </Col>

                          {/* URREA */}
                          {this.state.apiURREA && (
                            <Col xs={24} sm={12} lg={24}>
                              <BoxItem style={{ padding: '10px' }}>
                                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '13px' }}>
                                  URREA
                                </div>
                                <Row gutter={[8, 8]}>
                                  <Col xs={24} sm={12} lg={10}>
                                    <FormItem
                                      label="Insumo"
                                      name="insumoURREA"
                                      margin
                                      labelCol={{ span: 10 }}
                                      wrapperCol={{ span: 14 }}
                                      initialValue={false}
                                      valuePropName="checked"
                                    >
                                      <CheckItem
                                        disabled={!this.state.apiURREA}
                                        onChange={(value) => {
                                          this.setState({ insumoURREA: value });
                                        }}
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col xs={24} sm={12} lg={14}>
                                    {this.state.insumoURREA && (
                                      <FormItem
                                        label="Código"
                                        name="codigoProducto"
                                        margin
                                        labelCol={{ span: 6}}
                                        wrapperCol={{ span: 18 }}
                                      >
                                        <Search
                                          placeholder="Código"
                                          allowClear
                                          size="small"
                                          value={this.state.codigoURREA}
                                          onChange={(e) => this.setState({ codigoURREA: e.target.value })}
                                          onSearch={(value) => {
                                            if (!value || value.trim() === "") {
                                              return;
                                            }
                                            this.onSearchInsumoURREA(value);
                                          }}
                                        />
                                      </FormItem>
                                    )}
                                  </Col>
                                </Row>
                              </BoxItem>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                   </>

                ),
              },
            ]}
          />

        <div style={{ marginTop: 25 }}>
         <TabbedDynamicTable
            formInstance={this.formRef}
            defaultActiveKey="General"
            onTabChange={(key) => {
              if (key === 'envio' && !this.state.todasMaterialesPeligrosos) {
                this.consultarEnvio()
              }
              if (key === 'existencias') {
                this.consultarExistencias()
              }
              if (key === 'logistica') {
                this.consultarLogistica()
              }
              if (key === 'kardex') {
                this.consultarKardex()
              }
              if (key === 'proyecciones') {
                this.consultarProyecciones()
              }
              if (key === 'historialCostos' && !this.state.todosUsuarios) {
                this.consultarUsuarios()
              }
              if (key === 'categorias') {
                this.cargarCategoriasDeTab()
              }
            }}
            tabs={[
              {
              key: 'General',
              label: 'General',
              forceRender: true,
              customContent: (
                <GeneralFormLayout

                cards={[
                  {
                  title: "TIPO DE INSUMO",
                  lg: 5,
                  content: (
                    <>
                      <Row gutter={[8, 8]}>
                        <Col span={12} xs={24} sm={12} lg={23} xl={23}>
                          <FormItem
                            name="inventariable"
                            label="Inventariable"
                            margin
                            valuePropName="checked"
                            initialValue={true}
                            specialLayoutSwitch
                          >
                            <SwitchItem
                              disabled={
                                this.state.familiaGastoNoDeducible
                              }
                              onChange={(value) => {
                                if (!value) {
                                  this.formRef.current.setFieldsValue({ marbetes: false, lotesCaducidades: false });
                                } else {
                                  this.formRef.current.setFieldsValue({ flete: false });
                                }
                                this.setState({ inventariable: value });
                              }}
                            />
                          </FormItem>


                        {this.props.marbetes && (

                            <FormItem
                              name="marbetes"
                              label="Marbetes"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                            >
                              <SwitchItem disabled={!this.state.inventariable || this.state.utilizado || this.state.familiaGastoNoDeducible} />
                            </FormItem>

                        )}

                        {this.props.lotesCaducidades && (

                            <FormItem
                              name="lotesCaducidades"
                              label="Lotes y Caducidades"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Utilizar para llevar un control de lotes y caducidades en las compras y ventas" }}
                            >
                              <SwitchItem disabled={!this.state.inventariable} />
                            </FormItem>

                        )}

                        {this.props.fletes && (

                            <FormItem
                              name="flete"
                              label="Flete"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Activara el transporte de mercancia en la venta. Al igual que la carta porte si se tienen los certificados." }}
                            >
                              <SwitchItem disabled={this.state.inventariable || this.state.familiaGastoNoDeducible} />
                            </FormItem>

                        )}
                        <Col span={12} xs={24} sm={12} lg={24} xl={24}>
                              <FormItem
                                    shouldUpdate={(prev, curr) => prev.inventariable !== curr.inventariable || prev.lotesCaducidades !== curr.lotesCaducidades || prev.vehiculo !== curr.vehiculo}
                                    noStyle
                                  >
                                    {({ getFieldValue }) => {
                                      const inventariable = getFieldValue('inventariable');
                                      const lotesCaducidades = getFieldValue('lotesCaducidades');
                                      const vehiculo = getFieldValue('vehiculo');

                                          if (inventariable && lotesCaducidades) {
                                            return (

                                                <>
                                                <FormItem
                                                  name="vehiculo"
                                                  label="Vehículo"
                                                  margin
                                                  valuePropName="checked"
                                                  specialLayoutSwitch
                                                  tooltip={{ title: "Activara este insumo como vehiculo" }}

                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                {vehiculo && (
                                                  <FormItem
                                                    name="desactivarComplementoVehicular"
                                                    label="Des. comp. vehicular"
                                                    margin
                                                    valuePropName="checked"
                                                    specialLayoutSwitch
                                                    tooltip={{ title: "Desactivara el complemento vehicular para este insumo" }}
                                                  >
                                                    <SwitchItem />
                                                  </FormItem>
                                                )}
                                                {this.props.escuela && (
                                                  <>
                                                    <FormItem
                                                      name="libroVirtual"
                                                      label="Libro Virtual"
                                                      margin
                                                      valuePropName="checked"
                                                      specialLayoutSwitch
                                                      tooltip={{ title: "Al confirmarse el pago de una venta con este insumo, se le asignará automáticamente un código de lote único y ya no se pedirá empacarlo físicamente." }}
                                                    >
                                                      <SwitchItem />
                                                    </FormItem>
                                                    <FormItem
                                                      shouldUpdate={(prev, curr) => prev.libroVirtual !== curr.libroVirtual}
                                                      noStyle
                                                    >
                                                      {({ getFieldValue: getFV }) =>
                                                        getFV('libroVirtual') && (
                                                          <FormItem
                                                            name="instruccionesLibroVirtual"
                                                            label="Instrucciones del código"
                                                            margin
                                                            tooltip={{ title: "Se incluye en el correo que recibe el cliente al pagar." }}
                                                          >
                                                            <TextAreaItem rows={3} />
                                                          </FormItem>
                                                        )
                                                      }
                                                    </FormItem>
                                                  </>
                                                )}
                                                </>
                                            );
                                          }
                                          return null;
                                        }}
                                      </FormItem>
                                </Col>
                              </Col>
                            </Row>
                          </>
                            )
                          },
                          {
                          lg: 12,
                          group: [
                            {
                              title: "DATOS DE VENTA",
                              content: (
                                <>
                                    <div style={{
                                      textAlign: 'center',
                                      marginBottom: 8,
                                      fontWeight: 600,
                                      fontSize: '13px'
                                    }}>
                                      DATOS FISCALES
                                    </div>
                                    <FormItem
                                      label="Familia"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                    >
                                      <Input.Group compact>
                                        <FormItem name="familiaId" required noStyle>
                                          <SelectItem
                                            disabled={this.state.utilizado}
                                            placeholder="Familia"
                                            width="85%"
                                            onChange={this.onChangeFamlia.bind(this)}
                                          >
                                            {this.state.objetoFamilia}
                                          </SelectItem>
                                        </FormItem>
                                        <ButtonItem
                                          disabled={this.state.utilizado}
                                          icon={<PlusOutlined />}
                                          style={{ width: 28, height: 28, marginLeft: 5 }}
                                          onClick={this.abrirAgregarFamilia.bind(this)}
                                        />
                                      </Input.Group>
                                    </FormItem>
                                    <FormItem
                                      label="Tipo Ins."
                                      margin
                                      name="tipoDeInsumoId"
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                    >
                                      <SelectItem placeholder="Tipo de Insumo">
                                        {this.state.objetoTipoDeInsumo}
                                      </SelectItem>
                                    </FormItem>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.venta !== curr.venta || prev.equivalencias !== curr.equivalencias}
                                  >
                                    {({ getFieldValue }) => {
                                      const venta = getFieldValue('venta');
                                      const equivalencias = getFieldValue('equivalencias');
                                      const equivalenciasVenta = equivalencias && equivalencias.length > 0
                                        ? equivalencias.some(equivalencia => equivalencia?.venta)
                                        : false;

                                      if (venta || equivalenciasVenta) {
                                        return (
                                          <BoxItem style={{ padding: '10px', marginTop: 10 }}>
                                            <div style={{
                                              textAlign: 'center',
                                              marginBottom: 8,
                                              fontWeight: 600,
                                              fontSize: '13px'
                                            }}>
                                              CODIGOS SAT
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, marginTop: 0 }}>
                                              <FormItem
                                                label="Codigo Sat"
                                                name="codigoSatId"
                                                required
                                                margin
                                                style={{ flex: 1, marginBottom: 0 }}
                                              >
                                                <SelectItem
                                                  mostrarCarga
                                                  loading={this.state.buscarInfoCode}
                                                  placeholder="Codigo Sat"
                                                  onSearch={(value) => { this.onChangeCodigo(value) }}
                                                >
                                                  <Option disabled>Escriba para buscar el codigo</Option>
                                                  {this.state.objetoCodigoSat}
                                                </SelectItem>
                                              </FormItem>
                                              <ButtonItem
                                                style={{ minWidth: 40, padding: '0 8px', height: 28, fontSize: 12 }}
                                                onClick={() => window.open("http://pys.sat.gob.mx/PyS/catPyS.aspx", "_blank")}
                                                size="small"
                                              >
                                                <span style={{ whiteSpace: 'nowrap' }}>Conoce tu código SAT</span>
                                              </ButtonItem>
                                            </div>
                                          </BoxItem>
                                        );
                                      }
                                      return null;
                                    }}
                                  </FormItem>
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) => prev.venta !== curr.venta || prev.familiaId !== curr.familiaId}
                                  >
                                    {({ getFieldValue }) => {
                                      const venta = getFieldValue('venta');
                                      const familiaId = getFieldValue('familiaId');
                                      let familia;

                                      if (familiaId) {
                                        familia = this.state?.todasFamilia?.find(
                                          valueTF => valueTF._id.toString() === familiaId.toString()
                                        );
                                      }

                                      if (venta && (!familia?.cuentaIngresoContadoId || !familia?.cuentaIngresoCreditoId)) {
                                        return (
                                          <BoxItem style={{ padding: '10px', marginTop: 10 }}>
                                            <div style={{
                                              textAlign: 'center',
                                              marginBottom: 8,
                                              fontWeight: 600,
                                              fontSize: '13px'
                                            }}>
                                              CUENTAS DE INGRESO
                                            </div>
                                            <FormItem label="Cuenta Contado" labelCol={{ span: 6 }}wrapperCol={{ span: 18}}  margin>
                                              <Input.Group compact>
                                                <FormItem name="cuentaIngresoContadoId" required noStyle>
                                                  <SelectItem placeholder="Cuenta Ingreso Contado" width="80%">
                                                    {this.state.objetoCuentasContablesFinales}
                                                  </SelectItem>
                                                </FormItem>
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                  style={{ width: 28, height: 28, marginLeft: 5 }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                />
                                              </Input.Group>
                                            </FormItem>
                                            <FormItem label="Cuenta Credito" labelCol={{ span: 6 }}wrapperCol={{ span: 18}} margin>
                                              <Input.Group compact>
                                                <FormItem name="cuentaIngresoCreditoId" required noStyle>
                                                  <SelectItem placeholder="Cuenta Ingreso Credito" width="80%">
                                                    {this.state.objetoCuentasContablesFinales}
                                                  </SelectItem>
                                                </FormItem>
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                  style={{ width: 28, height: 28, marginLeft: 5 }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                />
                                              </Input.Group>
                                            </FormItem>
                                          </BoxItem>
                                        );
                                      }
                                      return null;
                                    }}
                                  </FormItem>
                                </>
                              )
                            },
                            ]
                          },
                          ]}
                        />
                      )
                    },

                  ...(this.state.venta ? [{
                    key: 'listaPrecios',
                    label: 'Lista de Precios',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                            title= "LISTA DE PRECIOS"
                            lg= "100%"
                            style={{ marginTop: 10 }}
                      >

                <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta}>
                  {({ getFieldValue }) => {
                    const venta = getFieldValue('venta');

                    return (
                      <>
                        {/* Encabezado de la tabla */}
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                            gap: 8,
                            padding: '8px 12px',
                            background: '#fafafa',
                            border: '1px solid #f0f0f0',
                            borderRadius: 8,
                            fontWeight: 600
                          }}
                        >
                          <div>Precio</div>
                          <div style={{ textAlign: "center" }}>% Fijo</div>
                          <div style={{ textAlign: "center" }}>% Real</div>
                          <div style={{ textAlign: "center" }}>Precio</div>
                        </div>

                        <FormInitial.List name="precios">
                          {(fields) => (
                            <div style={{ marginTop: 8 }}>
                              {fields.map(({ key, name }) => (
                                <div
                                  key={key}
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                    gap: 8,
                                    alignItems: 'center',
                                    padding: '8px 12px',
                                    border: '1px solid #f0f0f0',
                                    borderTop: 'none',
                                    background: '#fff'
                                  }}
                                >
                                  {/* Col 1: Nombre de la lista */}
                                  <div style={{ fontWeight: 500 }}>
                                    {this.state.precios?.[key]?.nombre || `Precio ${key + 1}`}
                                  </div>

                                  {/* Col 2: porcentajeFijo */}
                                  <div>
                                    <FormItem
                                      name={[name, 'porcentajeFijo']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem porcentaje disabled={!venta} />
                                    </FormItem>
                                  </div>

                                  {/* Col 3: porcentaje */}
                                  <div>
                                    <FormItem
                                      name={[name, 'porcentaje']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem
                                        porcentaje
                                        disabled={!venta}
                                        onChange={(value) => {
                                          const arrayValue = this.formRef.current.getFieldValue('precios');
                                          const valueCosto = this.formRef.current.getFieldValue('costo');
                                          if (!valueCosto) return;

                                          if (this.state.calcularPreciosSobre) {
                                            arrayValue[key].precio = ((valueCosto * (100 + value)) / 100).toFixed(2);
                                          } else {
                                            arrayValue[key].precio = (valueCosto / ((100 - value) / 100)).toFixed(2);
                                          }

                                          this.formRef.current.setFieldsValue({ precios: arrayValue });
                                        }}
                                      />
                                    </FormItem>
                                  </div>

                                  {/* Col 4: precio */}
                                  <div>
                                    <FormItem
                                      name={[name, 'precio']}
                                      required
                                      numberCero
                                      noStyle
                                    >
                                      <InputNumberItem
                                        placeholder={`Precio de Venta ${this.state.precios?.[key]?.nombre || ''}`}
                                        dinero
                                        disabled={!venta}
                                        onChange={(value) => {
                                          const arrayValue = this.formRef.current.getFieldValue('precios');
                                          const valueCosto = this.formRef.current.getFieldValue('costo');
                                          if (!valueCosto) return;

                                          const calculado = this.state.calcularPreciosSobre
                                            ? ((value - valueCosto) / valueCosto) * 100
                                            : ((value - valueCosto) / value) * 100;
                                          arrayValue[key].porcentaje = this.clampPorcentaje(calculado).toFixed(2);

                                          this.formRef.current.setFieldsValue({ precios: arrayValue });
                                        }}
                                      />
                                    </FormItem>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </FormInitial.List>
                      </>
                    );
                  }}
                </FormItem>

                      </DynamicCardForm>
                    )
                  }] : []),
              
                    {
                    key: 'complementos',
                    label: 'Complementos',
                    forceRender: true,
                    customContent: (
                      <>
                       <DynamicCardForm title="COMPLEMENTOS" xs={24} sm={24} md={12} lg={10} xl={10} style={{ marginTop: 10 }}
                       >
                         <>
                        <FormItem shouldUpdate={(prev, curr) => prev.venta !== curr.venta} noStyle >
                          {({ getFieldValue }) => {
                            const venta = getFieldValue('venta');
                            if (venta) {
                              return (
                                <Row gutter={[4, 2]} style={{ marginBottom: 4 }} >
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="observacionesVenta"
                                      label="Observaciones"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara cambiar observaciones en ventas, estas solamente se ven en el pdf" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="verInsumoVenta"
                                      label="Ver Insumo"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara ver el insumo en ventas" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                  <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="insumoCambio"
                                      label="Insumo Cambio"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara que el insumo sea de cambio de cotizaciones a pedido o venta" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="leyendaVenta"
                                      label="Leyenda"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara cambiar leyenda en ventas" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="descripcionLargaVenta"
                                      label="Desc. Larga en PDF"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Al agregar este insumo a una cotización, pedido, embarque o venta, su descripción larga se imprime en el PDF debajo del concepto. Se puede quitar o poner en cada renglón." }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                   <Col span={12} xs={12} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="segundoTicket"
                                      label="2º Ticket"
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Activara el segundo ticket en el punto de venta" }}
                                      style={{ marginBottom: 4 }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>
                                </Row>
                              );
                            }
                            return null;
                          }}
                        </FormItem>
                        <FormItem shouldUpdate={(prev, curr) => prev.venta !== curr.venta} noStyle>
                          {({ getFieldValue }) => {
                            const venta = getFieldValue('venta');
                            if (venta) {
                              return (
                                <>
                                  <Row gutter={16}> 
                                   <Col span={6} xs={24} sm={12} lg={8} xl={8}>
                                    <FormItem
                                      name="noFacturable"
                                      label="No Facturable"
                                      margin
                                      valuePropName="checked"
                                      specialLayoutSwitch
                                      tooltip={{ title: "Este insumo no podra ser facturado si se activa" }}
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                  </Col>

                                  {this.state.imprimirImagenesCotizaciones && (
                                     <Col span={6} xs={24} sm={12} lg={8} xl={8}>
                                      <FormItem
                                        name="cargarImagen"
                                        label="Cargar Imagen"
                                        margin
                                        valuePropName="checked"
                                        specialLayoutSwitch
                                        tooltip={{ title: "Al activar se podrá cargar una imagen en la cotización" }}
                                      >
                                        <SwitchItem />
                                      </FormItem>
                                    </Col>
                                  )}
                                   </Row>
                                </>
                              );
                            }
                            return null;
                          }}
                        </FormItem>
                        <Row gutter={[4, 2]} style={{ marginTop: 12 }}>
                          <Col span={24}>
                            <FormItem
                              label="Proveedor"
                              name="proveedorDefaultId"
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 19 }}
                              style={{ marginBottom: 4 }}
                            >
                              <SelectItem placeholder="Proveedor default">
                                {this.state.objetoProveedores}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col span={24}>
                            <FormItem
                              label="Compra Mín."
                              name="catidadMinCompra"
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 19 }}
                              numberCero
                              style={{ marginBottom: 0 }}
                            >
                              <InputNumberItem placeholder="Compra Mínima" />
                            </FormItem>
                          </Col>
                        </Row>
                        <Row gutter={[4, 2]} style={{ marginTop: 8 }}>
                          <Col span={24}>
                            <FormItem
                              name="toleranciaRecepcion"
                              label="Tolerancia al Recibir"
                              margin
                              valuePropName="checked"
                              specialLayoutSwitch
                              tooltip={{ title: "Permite recibir (físicamente o por factura) una cantidad mayor a la pedida en la Orden de Compra, hasta el tope configurado, sin bloquear el guardado." }}
                            >
                              <SwitchItem />
                            </FormItem>
                          </Col>
                        </Row>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.toleranciaRecepcion !== curr.toleranciaRecepcion}>
                          {({ getFieldValue }) => {
                            if (!getFieldValue('toleranciaRecepcion')) return null;
                            return (
                              <Row gutter={[4, 2]}>
                                <Col span={12}>
                                  <FormItem
                                    name="tipoToleranciaRecepcion"
                                    label="Tipo"
                                    required
                                    initialValue={1}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <SelectItem placeholder="Tipo de tolerancia">
                                      <Option value={1}>Porcentaje</Option>
                                      <Option value={2}>Cantidad fija</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="valorToleranciaRecepcion"
                                    label="Valor"
                                    required
                                    gt={0}
                                    numberCero
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputNumberItem placeholder="Valor de la tolerancia" />
                                  </FormItem>
                                </Col>
                              </Row>
                            );
                          }}
                        </FormItem>
                      </>
                     </DynamicCardForm>
                     <DynamicCardForm title="CONFIGURACIÓN ADICIONAL" xs={24} sm={24} md={12} lg={10} xl={10} style={{ marginTop: 10 }}>
                          <FormItem
                            name="activarCuentaPredial"
                            label="Cuenta Predial"
                            margin
                            valuePropName="checked"
                            tooltip={{ title: "Activar para agregar el número de cuenta predial en las ventas" }}
                          >
                              <SwitchItem />
                          </FormItem>
                          <FormItem noStyle shouldUpdate={(prev, curr) => prev.activarCuentaPredial !== curr.activarCuentaPredial}>
                            {({ getFieldValue }) => {
                              const activarCuentaPredial = getFieldValue('activarCuentaPredial');
                              if (activarCuentaPredial) {
                                return (
                                  <FormItem
                                    name="cuentaPredial"
                                    label="Número de Cuenta Predial"
                                    required
                                    pattern
                                  >
                                    <InputItem placeholder="Número de Cuenta Predial" />
                                  </FormItem>
                                );
                              }
                              return null;
                            }}
                          </FormItem>
                     </DynamicCardForm>
                     </>
                    )
                   },

                    {
                    key: 'archivoGrafico',
                    label: 'Archivo Gráfico',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                        title="ARCHIVO GRÁFICO"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <div style={{ marginBottom: 8, fontSize: 12, color: '#8c8c8c', lineHeight: 1.4 }}>
                          <strong>Recomendación de imagen:</strong> usa imágenes <strong>cuadradas (1:1), 1200×1200&nbsp;px</strong>,
                          fondo blanco o transparente y el producto centrado, para que todos los productos
                          se vean parejos en la tienda online. Formatos: JPG/PNG/WebP, máx. 5&nbsp;MB.
                        </div>
                        <Row gutter={[12, 8]} justify="space-between">
                          <Col flex="1">
                            <FormItem name="fotoPrincipal" noStyle>
                              <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFilePrincipal(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosPrincipal}
                                customRequest={this.customRequestPrincipal.bind(this)}
                                onPreview={this.handlePreview}
                                maxCount={1}
                                accept="image/*"
                                beforeUpload={(file) => {
                                  const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
                                  const isLt5M = file.size / 1024 / 1024 < 5;
                                  if (!isImage) {
                                    message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  if (!isLt5M) {
                                    message.error(`${file.name} excede el tamaño máximo de 5MB`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  return true;
                                }}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Foto Principal</div>
                                </div>
                              </Upload>
                            </FormItem>
                          </Col>

                          <Col flex="1">
                            <FormItem name="fichaTecnica" noStyle>
                              <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFileFicha(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosTecnica}
                                customRequest={this.customRequestFicha.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Ficha Técnica</div>
                                </div>
                              </Upload>
                            </FormItem>
                          </Col>

                          <Col flex="1">
                            <FormItem name="fotos" noStyle>
                              <Upload
                                listType="picture-card"
                                  itemRender={(originNode, file) => (
                                  <div style={{ display: 'inline-block', textAlign: 'center', marginRight: 8 }}>
                                    {originNode}
                                    <div style={{
                                      fontSize: 12,
                                      marginTop: 6,
                                      maxWidth: 104,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                      {file.name}
                                    </div>
                                  </div>
                                )}
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFileFotos(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined onClick={(e) => e.preventDefault()} />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosFotos}
                                customRequest={this.customRequestFotos.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                                accept="image/*"
                                beforeUpload={(file) => {
                                  const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
                                  const isLt5M = file.size / 1024 / 1024 < 5;
                                  if (!isImage) {
                                    message.error(`${file.name} no es una imagen válida`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  if (!isLt5M) {
                                    message.error(`${file.name} supera los 5 MB`);
                                    return Upload.LIST_IGNORE;
                                  }
                                  return true;
                                }}
                              >
                                <div>
                                  <PictureOutlined />
                                  <div style={{ marginTop: 8 }}>Fotos</div>
                                </div>
                              </Upload>
                            </FormItem>
                          </Col>
                        </Row>
                      </DynamicCardForm>
                    )
                  },

                    {
                      key: 'relaciones',
                      label: 'Relaciones Automáticas',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm
                              title= "RELACIONES AUTOMÁTICAS"
                              lg= "100%"
                              style={{ marginTop: 10 }}
                        >

                                <FormInitial.List name="relacionesAutomaticas">
                                  {(fields, { add, remove }) => (
                                    <>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={8} style={{ marginBottom: 8}}>

                                            <FormItem
                                              name={[name, "codigoSatId"]}
                                              fieldKey={[arrayKey, "codigoSatId"]}
                                              required
                                              noStyle
                                              labelCol={{ span: 6 }}
                                              wrapperCol={{ span: 18}}
                                            >
                                              <SelectItem
                                                mostrarCarga
                                                width='100%'
                                                loading={this.state.buscarInfoCodeRA[arrayKey]}
                                                placeholder="Codigo Sat"
                                                onSearch={(value) => {
                                                  this.onChangeCodigoRelacionesAutomaticas(value, arrayKey)
                                                }}
                                                onChange={(value) => {
                                                  this.onChangeSelectCodigoRelacionesAutomaticas(value, arrayKey)
                                                }}
                                              >
                                                <Option disabled>Escriba para buscar el codigo</Option>
                                                {this.state.objetoCodigoSatRA[arrayKey] ? this.state.objetoCodigoSatRA[arrayKey] : null}
                                              </SelectItem>
                                            </FormItem>
                                          <Col span={2}>
                                            <div style={{ textAlign: 'center', lineHeight: '32px' }}>
                                              <MinusCircleOutlined
                                                onClick={() => {
                                                  remove(name)
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                      <div style={{ textAlign: 'center', marginTop: 12 }}>
                                        <ButtonItem
                                          type="primary"
                                          onClick={() => {
                                            this.onChangeCodigoRelacionesAutomaticas("151015", fields.length)
                                            add()
                                          }}
                                          icon={<PlusOutlined />}
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    </>
                                  )}
                                </FormInitial.List>
                        </DynamicCardForm>
                      ),
                    },
                    {
                      key: 'valuacion',
                      label: 'Valuación de Inventarios',
                      forceRender: true,
                      customContent: (
                       <DynamicCardForm
                        title= "VALUACION DE INVENTARIOS"
                        lg= "100%"
                        style={{ marginTop: 10 }}
                       >

                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.inventariable !== curr.inventariable} >
                          {({ getFieldValue }) => {
                            let inventariable = getFieldValue('inventariable')
                            if (inventariable) {
                              return (
                                <>
                                    <FormItem
                                      name="valuacionInventarios"
                                      label="Valuacion"
                                      required
                                      margin
                                      tooltip="Metodo de valuacion de inventarios, si se cambia se tendra que recalcular algunas cuestiones, cambielo solo si es necesario"
                                    >
                                      <SelectItem disabled placeholder="Seleccionar lista de precios">
                                        <Option value={1}>PEPS (Primeras Entradas, Primeras Salidas)</Option>
                                        <Option value={2}>Costo Promedio Ponderado</Option>
                                        <Option value={3}>Costo Especifico</Option>
                                      </SelectItem>
                                    </FormItem>

                                </>
                              )
                            } else {
                              return null
                            }
                          }}
                        </FormItem>
                      </DynamicCardForm>
                      )
                    },
                    {
                      key: 'equivalencias',
                      label: 'Equivalencias',
                      forceRender: true,
                      customContent: (
                        <DynamicCardForm
                              title= "EQUIVALENCIAS"
                              lg= "100%"
                              style={{ marginTop: 10 }}
                        >
                      {/* Banner explicativo */}
                      <div style={{
                        background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)',
                        border: '1px solid #91d5ff',
                        borderRadius: 10,
                        padding: '12px 16px',
                        marginBottom: 18,
                        display: 'flex',
                        gap: 12,
                        alignItems: 'flex-start',
                      }}>
                        <div style={{ fontSize: 22, lineHeight: 1, marginTop: 2 }}>💡</div>
                        <div>
                          <div style={{ fontWeight: 700, color: '#0050b3', marginBottom: 4, fontSize: 13 }}>
                            ¿Qué es una equivalencia?
                          </div>
                          <div style={{ color: '#444', fontSize: 12.5, lineHeight: 1.6 }}>
                            Una equivalencia define cómo este insumo puede venderse en una <strong>presentación diferente</strong>.{' '}
                            El factor indica <em>cuántas unidades base</em> contiene esa presentación.
                          </div>
                          <div style={{
                            marginTop: 8,
                            background: '#fff',
                            border: '1px solid #bae7ff',
                            borderRadius: 6,
                            padding: '6px 10px',
                            fontSize: 12,
                            color: '#555',
                            display: 'inline-block',
                          }}>
                            <strong>Ejemplo:</strong> Si el insumo es <em>"Litro"</em> y cuesta $10, una equivalencia{' '}
                            <em>"Caja de 12 litros"</em> con factor <strong>12</strong> tendrá un costo automático de <strong>$120</strong>.
                          </div>
                        </div>
                      </div>

                      <FormInitial.List name="equivalencias">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(
                            ({ key, name, fieldKey, ...restField }, arrayKey) => (
                              <>
                                <Row>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      const descripcionProducto =
                                        getFieldValue("descripcion");
                                      const costo = getFieldValue("costo");
                                      const equivalencias =
                                        getFieldValue("equivalencias");
                                      if (!equivalencias[arrayKey]) return;
                                      const factor = equivalencias[arrayKey].equivalencia;
                                      const descEquiv = equivalencias[arrayKey].descripcion;
                                      const costoEquiv = factor ? costo / factor : 0;
                                      return (
                                        <div style={{
                                          width: '100%',
                                          background: '#f6ffed',
                                          border: '1px solid #b7eb8f',
                                          borderRadius: 6,
                                          padding: '5px 12px',
                                          marginBottom: 8,
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 8,
                                          flexWrap: 'wrap',
                                          fontSize: 12,
                                        }}>
                                          <span style={{ color: '#888' }}>Base:</span>
                                          <strong style={{ color: '#237804' }}>1 × {descripcionProducto || '—'}</strong>
                                          <span style={{ color: '#aaa' }}>⇄</span>
                                          <strong style={{ color: '#237804' }}>{factor || '?'} × {descEquiv || '—'}</strong>
                                          {factor ? (
                                            <span style={{ color: '#555', marginLeft: 4 }}>
                                              · Costo: <strong style={{ color: '#237804' }}>{dineroDisabledMask(costoEquiv || 0)}</strong>
                                              <span style={{ color: '#aaa', fontSize: 11, marginLeft: 4 }}>({dineroDisabledMask(costo || 0)} ÷ {factor})</span>
                                            </span>
                                          ) : null}
                                        </div>
                                      );
                                    }}
                                  </FormItem>
                                   <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                    <FormItem
                                      label="Permitir Venta"
                                      name={[name, "venta"]}
                                      fieldKey={[arrayKey, "venta"]}
                                      margin
                                      initialValue={true}
                                      valuePropName="checked"
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                    <FormItem
                                      label="Venta en línea"
                                      name={[name, "ventaOnline"]}
                                      fieldKey={[arrayKey, "ventaOnline"]}
                                      margin
                                      initialValue={false}
                                      valuePropName="checked"
                                    >
                                      <SwitchItem />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label="Descripción"
                                      name={[name, "descripcion"]}
                                      fieldKey={[arrayKey, "descripcion"]}
                                      required
                                      max={200}
                                      margin
                                      pattern
                                    >
                                      <InputItem placeholder="Descripción" />
                                    </FormItem>
                                    {/* Opcional: si se deja vacia, la equivalencia usa la
                                        clave del insumo (es la que termina en el
                                        NoIdentificacion del CFDI y en el PDF). */}
                                    <FormItem
                                      {...restField}
                                      label="Clave"
                                      name={[name, "clave"]}
                                      fieldKey={[arrayKey, "clave"]}
                                      max={100}
                                      margin
                                      pattern
                                    >
                                      <InputItem
                                        placeholder={
                                          this.formRef.current?.getFieldValue("clave")
                                            ? `Sin clave propia se usa: ${this.formRef.current.getFieldValue("clave")}`
                                            : "Sin clave propia se usa la del insumo"
                                        }
                                      />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label="Cliente"
                                      name={[name, "clienteId"]}
                                      fieldKey={[arrayKey, "clienteId"]}
                                      margin
                                    >
                                      <SelectClientesItem
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                        placeholder="Cliente (opcional)"
                                        allowClear
                                      />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label="Presentación para el cliente"
                                      name={[name, "presentacion"]}
                                      fieldKey={[arrayKey, "presentacion"]}
                                      max={200}
                                      margin
                                      pattern
                                    >
                                      <InputItem placeholder="Ej. Como la pide el cliente" />
                                    </FormItem>
                                    <FormItem
                                      {...restField}
                                      label={
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                          <span>Equivalencia</span>
                                          <CalculatorFilled
                                            onClick={() => this.abrirEquivModal(arrayKey)}
                                            style={{ cursor: 'pointer', fontSize: 15, color: '#91d5ff', transition: 'color 0.3s' }}
                                            title="Calcular equivalencia"
                                          />
                                        </div>
                                      }
                                      name={[name, "equivalencia"]}
                                      fieldKey={[arrayKey, "equivalencia"]}
                                      required
                                      margin
                                      number
                                    >
                                      <InputNumberItem
                                        placeholder="Equivalencia"
                                        onChange={this.onChangeCosto.bind(this)}
                                      />
                                    </FormItem>
                                    <FormItem label="Unidad" margin>
                                      <Input.Group compact>
                                        <FormItem
                                          {...restField}
                                          name={[name, "unidadId"]}
                                          fieldKey={[arrayKey, "unidadId"]}
                                          required
                                          margin
                                          pattern
                                          noStyle
                                        >
                                          <SelectItem
                                            placeholder="Unidad"
                                            width="90%"
                                          >
                                            {this.state.objetoUnidades}
                                          </SelectItem>
                                        </FormItem>
                                        <ButtonItem
                                          icon={<PlusOutlined />}
                                          style={{ width: "10%" }}
                                          onClick={this.abrirAgregarUnidad.bind(this)}
                                        />
                                      </Input.Group>
                                    </FormItem>
                                  </Col>
                                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                    <FormInitial.List
                                      name={[name, "precios"]}
                                      fieldKey={[arrayKey, "precios"]}
                                      initialValue={this.state.precios.map((value) => ({
                                        porcentajeFijo: value.porcentaje,
                                        porcentaje: value.porcentaje,
                                        nombre: value.nombre,
                                        precioId: value.precioId,
                                      }))}
                                    >
                                      {(fields) => (
                                        <>
                                          <div
                                            style={{
                                              display: 'grid',
                                              gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                              gap: 8,
                                              padding: '8px 12px',
                                              background: '#fafafa',
                                              border: '1px solid #f0f0f0',
                                              borderRadius: 8,
                                              fontWeight: 600
                                            }}
                                          >
                                            <div>Lista</div>
                                            <div style={{ textAlign: "center" }}>% Fijo</div>
                                            <div style={{ textAlign: "center" }}>% Real</div>
                                            <div style={{ textAlign: "center" }}>Precio</div>
                                          </div>

                                          <div style={{ marginTop: 8 }}>
                                            {fields.map(({ key, name }) => (
                                              <div
                                                key={key}
                                                style={{
                                                  display: 'grid',
                                                  gridTemplateColumns: '1.2fr 1fr 1fr 1.2fr',
                                                  gap: 8,
                                                  alignItems: 'center',
                                                  padding: '8px 12px',
                                                  border: '1px solid #f0f0f0',
                                                  borderTop: 'none',
                                                  background: '#fff'
                                                }}
                                              >
                                                <div style={{ fontWeight: 500 }}>
                                                  {this.state.precios?.[key]?.nombre || `Precio ${key + 1}`}
                                                </div>
                                                <div>
                                                  <FormItem
                                                    name={[name, "porcentajeFijo"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem porcentaje />
                                                  </FormItem>
                                                </div>
                                                <div>
                                                  <FormItem
                                                    name={[name, "porcentaje"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem
                                                      porcentaje
                                                      onChange={(value) => {
                                                        const equivalencias = this.formRef.current.getFieldValue("equivalencias");
                                                        const valueCosto = this.formRef.current.getFieldValue("costo");
                                                        if (!valueCosto) return;
                                                        if (!equivalencias[arrayKey]) return;
                                                        if (!equivalencias[arrayKey].equivalencia) return;

                                                        if (this.state.calcularPreciosSobre) {
                                                          equivalencias[arrayKey].precios[key].precio = (
                                                            ((valueCosto / equivalencias[arrayKey].equivalencia) * (100 + value)) / 100
                                                          ).toFixed(2);
                                                        } else {
                                                          equivalencias[arrayKey].precios[key].precio = (
                                                            valueCosto /
                                                            equivalencias[arrayKey].equivalencia /
                                                            ((100 - value) / 100)
                                                          ).toFixed(2);
                                                        }

                                                        this.formRef.current.setFieldsValue({ equivalencias });
                                                      }}
                                                    />
                                                  </FormItem>
                                                </div>
                                                <div>
                                                  <FormItem
                                                    name={[name, "precio"]}
                                                    required
                                                    numberCero
                                                    noStyle
                                                  >
                                                    <InputNumberItem
                                                      placeholder={`Precio de Venta ${this.state.precios?.[key]?.nombre || ''}`}
                                                      dinero
                                                      onChange={(value) => {
                                                        const equivalencias = this.formRef.current.getFieldValue("equivalencias");
                                                        const valueCosto = this.formRef.current.getFieldValue("costo");
                                                        if (!valueCosto) return;
                                                        if (!equivalencias[arrayKey]) return;
                                                        if (!equivalencias[arrayKey].equivalencia) return;

                                                        const base = valueCosto / equivalencias[arrayKey].equivalencia;

                                                        const calculado = this.state.calcularPreciosSobre
                                                          ? ((value - base) / base) * 100
                                                          : ((value - base) / value) * 100;
                                                        equivalencias[arrayKey].precios[key].porcentaje = this.clampPorcentaje(calculado).toFixed(2);

                                                        this.formRef.current.setFieldsValue({ equivalencias });
                                                      }}
                                                    />
                                                  </FormItem>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}
                                    </FormInitial.List>

                                    <FormItem>
                                      {/* No se borra: el _id de la equivalencia es lo que los
                                          renglones de ventas, pedidos y cotizaciones guardan en
                                          insumoId, asi que al guardar se marca como oculta y se
                                          puede recuperar con "Ver equivalencias ocultas". */}
                                      <Tooltip title="La equivalencia se oculta del catalogo al guardar. Los documentos que ya la usan no cambian, y la puedes recuperar con «Ver equivalencias ocultas».">
                                        <div style={{ float: "right", width: "auto" }}>
                                          <ButtonItem
                                            style={{ width: "auto" }}
                                            onClick={() => remove(name)}
                                            block
                                            rojo
                                            icon={<MinusCircleOutlined />}
                                          >
                                            Ocultar Equivalencia
                                          </ButtonItem>
                                        </div>
                                      </Tooltip>
                                    </FormItem>
                                  </Col>
                                </Row>
                                <Divider style={{ marginBottom: 10, marginTop: 5 }} />
                              </>
                            )
                          )}
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Equivalencia
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>

                    {this.state.equivalenciasOcultas.length > 0 && (
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <ButtonItem
                          type="dashed"
                          block
                          onClick={() =>
                            this.setState({
                              mostrarEquivalenciasOcultas:
                                !this.state.mostrarEquivalenciasOcultas,
                            })
                          }
                        >
                          {this.state.mostrarEquivalenciasOcultas
                            ? "Ocultar las equivalencias ocultas"
                            : `Ver equivalencias ocultas (${this.state.equivalenciasOcultas.length})`}
                        </ButtonItem>

                        {this.state.mostrarEquivalenciasOcultas && (
                          <div style={{ marginTop: 10 }}>
                            <p style={{ marginBottom: 5, color: "#8c8c8c" }}>
                              Estas equivalencias ya no se ofrecen en ventas, pero los
                              documentos que las usan las siguen mostrando igual. Al
                              restaurar una, vuelve al catalogo en cuanto guardes el insumo.
                            </p>
                            {this.state.equivalenciasOcultas.map((valueOculta) => (
                              <Row
                                key={String(valueOculta._id)}
                                align="middle"
                                style={{
                                  borderBottom: "1px solid #f0f0f0",
                                  padding: "6px 0",
                                  color: "#8c8c8c",
                                }}
                              >
                                <Col span={6}>{valueOculta.clave || "Sin clave"}</Col>
                                <Col span={10}>{valueOculta.descripcion}</Col>
                                <Col span={4}>{valueOculta.equivalencia}</Col>
                                <Col span={4}>
                                  <ButtonItem
                                    style={{ width: "auto", float: "right" }}
                                    onClick={() => this.restaurarEquivalencia(valueOculta)}
                                  >
                                    Restaurar
                                  </ButtonItem>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Modal calculadora + ejemplos de equivalencia */}
                    <ModalItem
                      title={(() => {
                        const idx = this.state.equivModal?.idx;
                        if (idx === null || idx === undefined) return 'Equivalencia';
                        const equivs = this.formRef.current?.getFieldValue('equivalencias');
                        const desc = equivs?.[idx]?.descripcion;
                        return desc ? `Equivalencia: ${desc}` : 'Equivalencia';
                      })()}
                      visible={this.state.equivModal?.visible}
                      onCancel={this.cerrarEquivModal}
                      onOk={this.cerrarEquivModal}
                      spinning={false}
                      width={620}
                      footer
                    >
                      {/* Diagrama en vivo */}
                      {(() => {
                        const idx = this.state.equivModal?.idx;
                        if (idx === null || idx === undefined) return null;
                        const equivalencias = this.formRef.current?.getFieldValue("equivalencias");
                        if (!equivalencias?.[idx]) return null;

                        const nombreBase = this.formRef.current?.getFieldValue("descripcion") || "Insumo";
                        const cantidadBase = this.state.equivCalcCantBase[idx] || 0;

                        const nombrePresentacion = equivalencias[idx].descripcion || "Presentación";
                        const cantidadPresentacion = this.state.equivCalcCantPres[idx] ?? 1;

                        const factor = cantidadPresentacion > 0 ? cantidadBase / cantidadPresentacion : 0;

                        return (
                          <div style={{ background: '#fafafa', border: '1px solid #d9d9d9', borderRadius: 6, padding: 14, marginBottom: 16 }}>
                            <Text strong style={{ color: AZUL_BIWO, fontSize: 13, display: 'block', marginBottom: 8 }}>
                              Así se ve tu equivalencia
                            </Text>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <DiagramaConversion
                                cajaA={{
                                  titulo: "Insumo base",
                                  cantidad: cantidadBase,
                                  unidad: nombreBase,
                                  color: AZUL_BIWO,
                                  fondo: AZUL_BIWO_BG,
                                }}
                                cajaB={{
                                  titulo: "Se vendería como",
                                  cantidad: cantidadPresentacion,
                                  unidad: nombrePresentacion,
                                  color: LIMA_BIWO,
                                  fondo: LIMA_BIWO_BG,
                                }}
                                factorTexto={
                                  <>Factor: <strong>{factor.toFixed(4)}</strong></>
                                }
                              />
                            </div>
                          </div>
                        );
                      })()}

                      {/* Calculadora */}
                      <div style={{ background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 6, padding: 14, marginBottom: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <Text strong style={{ color: '#1890ff', fontSize: 13 }}>Calculadora de equivalencia</Text>
                          <EyeOutlined
                            onClick={this.switchEquivModalMostrarEjemplos}
                            style={{
                              cursor: 'pointer',
                              fontSize: 15,
                              color: this.state.equivModalMostrarEjemplos ? '#1890ff' : '#91d5ff',
                              transition: 'color 0.3s',
                            }}
                            title="Ver ejemplos"
                          />
                        </div>
                        <br />
                        <Text type="secondary" style={{ fontSize: 11 }}>
                          Ingrese cuántas unidades base conforman la presentación. El factor se calcula automáticamente.
                        </Text>
                        <Row gutter={12} style={{ marginTop: 10 }}>
                          <Col span={12}>
                            <div style={{ padding: 10, background: 'white', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                              <Text strong style={{ display: 'block', marginBottom: 6, fontSize: 12 }}>Unidad base</Text>
                              <Text style={{ display: 'block', marginBottom: 6, fontSize: 11, color: '#595959' }}>
                                {this.formRef.current?.getFieldValue('descripcion') || ''}
                              </Text>
                              <Input.Group compact>
                                <InputNumber
                                  min={0}
                                  precision={4}
                                  value={this.state.equivCalcCantBase[this.state.equivModal?.idx] ?? 0}
                                  style={{ width: '44%', height: 36 }}
                                  onChange={(v) => this.setEquivCalcCantBase(this.state.equivModal?.idx, v)}
                                />
                                <Input
                                  value={this.resolverNombreUnidad(this.formRef.current?.getFieldValue('unidadId'))}
                                  disabled
                                  style={{ width: '56%', height: 36, backgroundColor: '#f5f5f5', textAlign: 'center', fontSize: 11 }}
                                  placeholder="unidad"
                                />
                              </Input.Group>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ padding: 10, background: 'white', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                              <Text strong style={{ display: 'block', marginBottom: 6, fontSize: 12 }}>Presentación</Text>
                              <Text style={{ display: 'block', marginBottom: 6, fontSize: 11, color: '#595959' }}>
                                {this.formRef.current?.getFieldValue('equivalencias')?.[this.state.equivModal?.idx]?.descripcion || ''}
                              </Text>
                              <Input.Group compact>
                                <InputNumber
                                  min={0.0001}
                                  precision={4}
                                  value={this.state.equivCalcCantPres[this.state.equivModal?.idx] ?? 1}
                                  style={{ width: '44%', height: 36 }}
                                  onChange={(v) => this.setEquivCalcCantPres(this.state.equivModal?.idx, v)}
                                />
                                <Input
                                  value={this.resolverNombreUnidad(this.formRef.current?.getFieldValue('equivalencias')?.[this.state.equivModal?.idx]?.unidadId)}
                                  disabled
                                  style={{ width: '56%', height: 36, backgroundColor: '#f5f5f5', textAlign: 'center', fontSize: 11 }}
                                  placeholder="unidad"
                                />
                              </Input.Group>
                            </div>
                          </Col>
                        </Row>
                        {(() => {
                          const idx = this.state.equivModal?.idx;
                          if (idx === null || idx === undefined) return null;
                          const pres = this.state.equivCalcCantPres[idx] || 0;
                          const base = this.state.equivCalcCantBase[idx] || 0;
                          if (!pres) return null;
                          const factor = parseFloat((base / pres).toFixed(4));
                          return (
                            <div style={{ textAlign: 'center', marginTop: 10, fontSize: 12, color: '#555' }}>
                              Factor calculado:{' '}
                              <strong style={{ color: '#237804', fontSize: 16 }}>{factor}</strong>
                            </div>
                          );
                        })()}
                      </div>

                      {/* Tabla de ejemplos (desplegable) */}
                      {this.state.equivModalMostrarEjemplos && (
                        <div style={{ background: 'white', border: '1px solid #d9d9d9', borderRadius: 6, overflow: 'hidden', fontSize: 11 }}>
                          <div style={{ padding: '8px 12px', background: '#fafafa', borderBottom: '1px solid #d9d9d9', fontWeight: 600, color: '#1890ff' }}>
                            Ejemplos de equivalencias
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr 44px 64px', background: '#e6f7ff', padding: '5px 8px', borderBottom: '1px solid #91d5ff', fontWeight: 600, color: '#0050b3', textAlign: 'center' }}>
                            <div>Presentación</div><div>Cant.</div><div>Unidad Base</div><div>Cant.</div><div>Factor</div>
                          </div>
                          {equivalenciaEjemplos.map((ej, i) => (
                            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr 44px 64px', padding: '5px 8px', borderBottom: '1px solid #f0f0f0', color: '#595959', textAlign: 'center', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                              <div>{ej.presentacion}</div>
                              <div>{ej.cantPres}</div>
                              <div>{ej.base}</div>
                              <div>{ej.cantBase}</div>
                              <div style={{ fontWeight: 600, color: '#262626' }}>{ej.factor}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </ModalItem>

                       </DynamicCardForm>
                      )
                    },
                    {
                      key: 'envio',
                      label: 'Envío',
                      forceRender: true,
                      customContent: (

                        <Spin spinning={this.state.loadingEnvios}>
                          <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
                            <DynamicCardForm title="DATOS MERCANCIA" span={24} xs={24} sm={24} lg={14} xl={14}>
                              <Row>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    name="dimensiones"
                                    label="Dimensiones"
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 15 }}
                                    pattern
                                  >
                                    <InputItem placeholder="Ejemplo:  59/40/36plg" />
                                  </FormItem>
                                  <FormItem
                                    label="Descripcion Materia"
                                    name="descripcionMateria"
                                    margin
                                    pattern
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 15 }}
                                    tooltip={{ title: "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario." }}
                                  >
                                    <InputItem placeholder="Descripcion Materia" />
                                  </FormItem>
                                   <FormItem label="Tipo Materia" name="tipoMateriaId" margin tooltip={{ title: "Atributo condicional para expresar el estado de la materia o producto al realizar una operación de comercio exterior a través de los distintos medios de transporte." }}
                                     labelCol={{ span: 10 }} wrapperCol={{ span: 15 }}>
                                    <SelectItem placeholder="Tipo Materia" width="100%">
                                      {this.state.objetoTiposMaterias}
                                    </SelectItem>
                                  </FormItem>
                                
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (getFieldValue('materialPeligroso')) {
                                        return (
                                          <>
                                            <FormItem label="Material Peligroso" name="materialPeligrosoId" margin required>
                                              <SelectItem placeholder="Material Peligroso" width="114%">
                                                {this.state.objetoMaterialesPeligrosos}
                                              </SelectItem>
                                            </FormItem>
                                            <FormItem
                                              name="numCAS"
                                              label="Numero CAS"
                                              margin
                                              labelCol={{ span: 8 }}
                                              wrapperCol={{ span: 16 }}
                                              pattern
                                              tooltip={{ title: "Atributo condicional para expresar el número Chemical Abstracts Service (CAS) con el que se identifica el compuesto químico de la sustancia tóxica." }}
                                            >
                                              <InputItem placeholder="Numero CAS" />
                                            </FormItem>
                                          </>
                                        )
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    label="Peso en KGM"
                                    name="pesoEnKGM"
                                    margin
                                    numberCero
                                  >
                                    <InputNumberItem placeholder="Peso en KGM" />
                                  </FormItem>
                                  <FormItem
                                    label="Clave STCC"
                                    name="claveSTCC"
                                    margin
                                    numberCero
                                    tooltip={{ title: "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario." }}
                                  >
                                    <InputNumberItem placeholder="Clave STCC" />
                                  </FormItem>
                                 
                                  <FormItem
                                    label="Material Peligroso"
                                    name="materialPeligroso"
                                    margin
                                    initialValue={false}
                                    valuePropName="checked"
                                  >
                                    <SwitchItem />
                                  </FormItem>

                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (getFieldValue('materialPeligroso')) {
                                        return (
                                          <>
                                            <FormItem label="Embalaje" name="embalajeId" margin required>
                                              <SelectItem placeholder="Embalaje" width="100%">
                                                {this.state.objetoEmbalajes}
                                              </SelectItem>
                                            </FormItem>
                                            <FormItem
                                              name="descripcionEmbalaje"
                                              label="Descripcion Embalaje"
                                              margin
                                              labelCol={{ span: 8 }}
                                              wrapperCol={{ span: 16 }}
                                              pattern
                                              required
                                            >
                                              <InputItem placeholder="Ejemplo: Cajas de madera contrachapada" />
                                            </FormItem>
                                          </>
                                        )
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                            <DynamicCardForm
                                  title="DETALLE MERCANCIA"
                                  span={12}
                                  xs={24}
                                  sm={24}
                                  lg={10}
                                  xl={10}
                                  headerRight={
                                    this.state.unidadPeso ? (
                                      <div style={{ textAlign: 'right', margin: 0, fontSize: 12, fontWeight: 500 }}>
                                        Unidad de peso: {this.state.unidadPeso.nombre} - {this.state.unidadPeso.unidadSat.c_ClaveUnidad}
                                      </div>
                                    ) : null
                                  }
                                >
                              <FormItem label="Peso Bruto" name="pesoBruto" margin numberCero>
                                <InputNumberItem placeholder="Peso Bruto" />
                              </FormItem>
                              <FormItem label="Peso Neto" name="pesoNeto" margin numberCero>
                                <InputNumberItem placeholder="Peso Neto" />
                              </FormItem>
                              <FormItem label="Peso Tara" name="pesoTara" margin numberCero>
                                <InputNumberItem placeholder="Peso Tara" />
                              </FormItem>
                            </DynamicCardForm>
                            <DynamicCardForm title="DATOS MERCANCIA" span={24} xs={24} sm={24} lg={14} xl={14}>
                              <FormItem
                                label="Sector COFEPRIS"
                                name="sectorCOFEPRIS"
                                margin
                                initialValue={false}
                                valuePropName="checked"
                              >
                                <SwitchItem />
                              </FormItem>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  if (getFieldValue('sectorCOFEPRIS')) {
                                    return (
                                      <>
                                        <FormItem label="Sector COFEPRIS" name="sectorCOFEPRISId" margin required>
                                          <SelectItem placeholder="Sector COFEPRIS" width="100%">
                                            {this.state.objetoSectoresCOF}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem name="nombreIngredienteActivo" label="Ingrediente Activo" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el nombre común del ingrediente activo de los precursores, químicos de uso dual, plaguicidas o fertilizantes que se trasladan a través de los distintos medios de transporte" }}>
                                          <InputItem placeholder="Ingrediente Activo" />
                                        </FormItem>
                                        <FormItem name="nombreQuimico" label="Nombre Quimico" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el nombre de la sustancia activa de los precursores, químicos de uso dual o sustancias tóxicas que se traslada a través de los distintos medios de transporte." }}>
                                          <InputItem placeholder="Nombre Quimico" />
                                        </FormItem>
                                        <FormItem name="denominacionGenericaProd" label="Denominacion Generica" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el fármaco o la sustancia activa del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}>
                                          <InputItem placeholder="Denominacion Generica" />
                                        </FormItem>
                                        <FormItem name="denominacionDistintivaProd" label="Denominacion Distintiva" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar la marca con la que se comercializa el producto o nombre que le asigna el laboratorio o fabricante a sus especialidades farmacéuticas con el fin de distinguirlas de otras similares del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}>
                                          <InputItem placeholder="Denominacion Distintiva" />
                                        </FormItem>
                                        <FormItem name="fabricante" label="Fabricante" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el nombre o razón social del establecimiento que realiza la fabricación o manufactura del medicamento, precursor, químico de uso dual, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte." }}>
                                          <InputItem placeholder="Fabricante" />
                                        </FormItem>
                                        <FormItem label="Forma Farmaceutica" name="formaFarmaceuticaId" margin>
                                          <SelectItem placeholder="Forma Farmaceutica" width="100%">
                                            {this.state.objetoFormasFarmaceuticas}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem label="Condiciones Especiales" tooltip={{ title: "Atributo condicional para expresar la condición en la cual es necesario mantener el medicamento, precursor, químico de uso dual, psicotrópicos o estupefacientes durante el traslado y almacenamiento." }} name="condicionEspecialId" margin>
                                          <SelectItem placeholder="Condiciones Especiales" width="100%">
                                            {this.state.objetoCondicionesEspeciales}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem name="registroSanitarioFolioAutorizacion" label="Registro Sanitario" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el registro sanitario o folio de autorización con el que cuenta la empresa para el traslado del medicamento, psicotrópico o estupefaciente." }}>
                                          <InputItem placeholder="Registro Sanitario" />
                                        </FormItem>
                                        <FormItem name="numRegSanPlagCOFEPRIS" label="Numero Registro" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para expresar el número de registro sanitario para plaguicidas o fertilizantes cuya importación, comercialización y uso están permitidos en México, mismo que emite la Comisión Intersecretarial para el Control del Proceso y Uso de Plaguicidas, Fertilizantes y Sustancias Tóxicas (CICLOPLAFEST)." }}>
                                          <InputItem placeholder="Numero Registro" />
                                        </FormItem>
                                        <FormItem name="datosFabricante" label="Datos Fabricante" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien produce o fabrica el ingrediente activo del plaguicida o fertilizante." }}>
                                          <InputItem placeholder="Datos Fabricante" />
                                        </FormItem>
                                        <FormItem name="datosFormulador" label="Datos Formulador" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien formula el ingrediente activo del plaguicida o fertilizante." }}>
                                          <InputItem placeholder="Datos Formulador" />
                                        </FormItem>
                                        <FormItem name="datosMaquilador" label="Datos Maquilador" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para registrar el país y nombre o razón social de quien maquila el ingrediente activo del plaguicida o fertilizante." }}>
                                          <InputItem placeholder="Datos Maquilador" />
                                        </FormItem>
                                        <FormItem name="usoAutorizado" label="Uso Autorizado" margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} pattern tooltip={{ title: "Atributo condicional para registrar el uso autorizado del plaguicida o fertilizante de acuerdo a la regulación del país." }}>
                                          <InputItem placeholder="Uso Autorizado" />
                                        </FormItem>
                                      </>
                                    )
                                  }
                                }}
                              </FormItem>
                            </DynamicCardForm>

                            
                          </Row>
                        </Spin>
                      )
                    },
                    {
                      key: 'formas',
                      label: 'Formas',
                      forceRender: true,
                      customContent: (
                         <DynamicCardForm
                          title="FORMAS"
                          lg= "100%"
                          style={{ marginTop: 10 }}
                        >

                      <FormInitial.List name="formasUtilizar">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.length > 0 ? (
                            <h1 style={{ textAlign: 'center' }}>Estas formas pertenecen al insumo</h1>
                          ) : null}
                          <table className="table">
                            {fields.length > 0 ? (
                              <thead>
                                <tr>
                                  <th className="th-border" style={{ width: '80%' }}>Forma</th>
                                  <th className="th-border" style={{ width: '2%' }}></th>
                                </tr>
                              </thead>
                            ) : null}
                            {fields.map(
                              ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                <tbody>
                                  <tr>
                                    <td className="td-border">
                                      <FormItem
                                        {...restField}
                                        name={[name, "insumoId"]}
                                        fieldKey={[arrayKey, "insumoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectInsumosItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          sinBorde
                                          autoFocus
                                          dropdownMatchSelectWidth={600}
                                          width="100%"
                                          placeholder="Insumo"
                                          tiposInsumos="activos"
                                        />
                                      </FormItem>
                                    </td>
                                    <td>
                                      <MinusCircleOutlined
                                        onClick={() => remove(name)}
                                        style={{
                                          alignSelf: "center",
                                          justifySelf: "center",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              )
                            )}
                          </table>
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              lessTime
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Forma
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>
                     </DynamicCardForm>
                      )
                    },
                    ...(this.state.ventaOnlineInsumo ? [{
                      key: 'insumosRelacionados',
                      label: 'Insumos Relacionados',
                      forceRender: true,
                      customContent: (
                         <DynamicCardForm
                          title="INSUMOS RELACIONADOS"
                          lg= "100%"
                          style={{ marginTop: 10 }}
                        >
                          <p style={{ marginBottom: 10, color: '#888', fontSize: 12 }}>
                            Estos productos se mostrarán como “Productos relacionados” únicamente en la
                            tienda en línea. Solo puedes seleccionar insumos con venta en línea activa
                            (los que aparecen ahí).
                          </p>
                      <FormInitial.List name="insumosRelacionados">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.length > 0 ? (
                            <h1 style={{ textAlign: 'center' }}>Estos productos se relacionan con el insumo</h1>
                          ) : null}
                          <table className="table">
                            {fields.length > 0 ? (
                              <thead>
                                <tr>
                                  <th className="th-border" style={{ width: '80%' }}>Insumo</th>
                                  <th className="th-border" style={{ width: '2%' }}></th>
                                </tr>
                              </thead>
                            ) : null}
                            {fields.map(
                              ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                <tbody>
                                  <tr>
                                    <td className="td-border">
                                      <FormItem
                                        {...restField}
                                        name={[name, "insumoId"]}
                                        fieldKey={[arrayKey, "insumoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectInsumosItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          sinBorde
                                          dropdownMatchSelectWidth={600}
                                          width="100%"
                                          placeholder="Seleccionar insumo relacionado"
                                          tiposInsumos="ventaOnline"
                                        />
                                      </FormItem>
                                    </td>
                                    <td>
                                      <MinusCircleOutlined
                                        onClick={() => remove(name)}
                                        style={{
                                          alignSelf: "center",
                                          justifySelf: "center",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              )
                            )}
                          </table>
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={() => add()}
                              lessTime
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Insumo Relacionado
                            </ButtonItem>
                          </FormItem>
                        </>
                      )}
                    </FormInitial.List>
                     </DynamicCardForm>
                      )
                    }] : []),
                  {
                    key: 'relacionesManuales',
                    label: 'Relaciones',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                        title="RELACIONES"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <FormInitial.List name="relaciones">
                          {(fields, { remove }) => (
                            <>
                              <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                                <ButtonItem
                                  type="primary"
                                  icon={<PlusOutlined />}
                                  onClick={() => this.abrirAsignarProveedor()}
                                >
                                  Agregar Relación
                                </ButtonItem>
                                {fields.length > 0 && (
                                  <Popconfirm
                                    title={`¿Eliminar ${relacionesSeleccionadas.length} relación(es) seleccionada(s)?`}
                                    onConfirm={() => this.eliminarRelacionesSeleccionadas()}
                                    okText="Sí"
                                    cancelText="No"
                                    disabled={relacionesSeleccionadas.length === 0}
                                  >
                                    <ButtonItem
                                      naranja
                                      icon={<DeleteOutlined />}
                                      disabled={relacionesSeleccionadas.length === 0}
                                    >
                                      Eliminar seleccionadas {relacionesSeleccionadas.length > 0 ? `(${relacionesSeleccionadas.length})` : ''}
                                    </ButtonItem>
                                  </Popconfirm>
                                )}
                                {fields.length > 0 && (
                                  <Popconfirm
                                    title="¿Eliminar TODAS las relaciones de este insumo?"
                                    onConfirm={() => this.eliminarTodasRelaciones()}
                                    okText="Sí"
                                    cancelText="No"
                                  >
                                    <ButtonItem danger icon={<DeleteOutlined />}>
                                      Eliminar todas
                                    </ButtonItem>
                                  </Popconfirm>
                                )}
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                                  {fields.length > 0 ? (
                                    <thead>
                                      <tr>
                                        <th className="th-border" style={{ width: "4%" }}></th>
                                        <th className="th-border" style={{ width: "10%" }}>Codigo</th>
                                        <th className="th-border" style={{ width: "18%" }}>Descripcion</th>
                                        <th className="th-border" style={{ width: "8%" }}>Unidad</th>
                                        <th className="th-border" style={{ width: "9%" }}>Conversion</th>
                                        <th className="th-border" style={{ width: "9%" }}>Compra Min.</th>
                                        <th className="th-border" style={{ width: "9%" }}>Costo</th>
                                        <th className="th-border" style={{ width: "9%" }}>Costo Unitario</th>
                                        <th className="th-border" style={{ width: "16%" }}>Proveedor</th>
                                        <th className="th-border" style={{ width: "8%" }}>Principal</th>
                                        <th className="th-border-sin-right" style={{ width: "5%" }}><DeleteOutlined /></th>
                                      </tr>
                                    </thead>
                                  ) : null}
                                  {fields.length > 0 ?
                                    fields.map(
                                      ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                        <tbody key={arrayKey}>
                                          <tr
                                            style={{
                                              backgroundColor: relacionesSeleccionadas.includes(arrayKey) ? '#e6f4ff' : undefined,
                                            }}
                                          >
                                            <td className="td-border" style={{ textAlign: 'center' }}>
                                              <Checkbox
                                                checked={relacionesSeleccionadas.includes(arrayKey)}
                                                onChange={() => this.toggleSeleccionarRelacion(arrayKey)}
                                              />
                                            </td>
                                            <td className="td-border">
                                              <FormItem label="Codigo" name={[name, "codigo"]} fieldKey={[arrayKey, "codigo"]} noStyle>
                                                <InputItem sinBorde disabled placeholder="Código" />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Descripción" name={[name, "descripcion"]} fieldKey={[arrayKey, "descripcion"]} noStyle>
                                                <InputItem sinBorde disabled placeholder="Descripción" />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const relaciones = getFieldValue('relaciones')
                                                  if (relaciones) {
                                                    if (relaciones[arrayKey]) {
                                                      if (relaciones[arrayKey].unidadInformativa) {
                                                        return (
                                                          <FormItem {...restField} label="Unidad" name={[name, "unidadInformativa"]} fieldKey={[arrayKey, "unidadInformativa"]} noStyle>
                                                            <InputItem sinBorde disabled />
                                                          </FormItem>
                                                        )
                                                      } else {
                                                        return (
                                                          <FormItem {...restField} label="Unidad" name={[name, "claveUnidad"]} fieldKey={[arrayKey, "claveUnidad"]} noStyle>
                                                            <InputItem sinBorde disabled />
                                                          </FormItem>
                                                        )
                                                      }
                                                    }
                                                  }
                                                }}
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Conversion" name={[name, "conversion"]} fieldKey={[arrayKey, "conversion"]} noStyle numberCero>
                                                <InputNumberItem sinBorde placeholder="Conversion" />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Compra Min." name={[name, "compraMin"]} fieldKey={[arrayKey, "compraMin"]} noStyle>
                                                <InputNumberItem sinBorde placeholder="Compra Min." />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Costo" name={[name, "costo"]} fieldKey={[arrayKey, "costo"]} noStyle>
                                                <InputNumberItem dinero sinBorde placeholder="Costo" />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Costo Unitario" name={[name, "costoUnitario"]} fieldKey={[arrayKey, "costoUnitario"]} noStyle>
                                                <InputNumberItem dineroDisabled sinBorde disabled placeholder="Costo Unitario" />
                                              </FormItem>
                                            </td>
                                            <td className="td-border">
                                              <FormItem {...restField} label="Proveedor" name={[name, "proveedorId"]} fieldKey={[arrayKey, "proveedorId"]} noStyle>
                                                <SelectItem sinBorde style={{ width: "100%" }} disabled placeholder="Proveedor">
                                                  {this.state.objetoProveedores}
                                                </SelectItem>
                                              </FormItem>
                                            </td>
                                            <td className="td-border" style={{ textAlign: 'center' }}>
                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue, setFieldsValue }) => {
                                                  const relaciones = getFieldValue('relaciones') || [];
                                                  const relacionActual = relaciones[arrayKey] || {};
                                                  return (
                                                    <Checkbox
                                                      checked={!!relacionActual.principal}
                                                      onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        const proveedorIdActual = relacionActual.proveedorId;
                                                        const nuevasRelaciones = relaciones.map((relacion, idx) => {
                                                          if (idx === arrayKey) {
                                                            return { ...relacion, principal: checked, agregadoSinXml: checked ? false : relacion.agregadoSinXml };
                                                          }
                                                          if (checked && relacion.proveedorId === proveedorIdActual) {
                                                            return { ...relacion, principal: false };
                                                          }
                                                          return relacion;
                                                        });
                                                        setFieldsValue({ relaciones: nuevasRelaciones });
                                                      }}
                                                    />
                                                  );
                                                }}
                                              </FormItem>
                                            </td>
                                            <td className="td-border-sin-right" style={{ textAlign: 'center' }}>
                                              <FormItem noStyle>
                                                <ButtonItem
                                                  danger
                                                  size="small"
                                                  onClick={(e) => { e.stopPropagation(); remove(name); }}
                                                  icon={<DeleteOutlined />}
                                                  disabled={relacionesSeleccionadas.length > 0}
                                                />
                                              </FormItem>
                                            </td>
                                          </tr>
                                        </tbody>
                                      )
                                    )
                                    :
                                    <h1>No existe ninguna relación todavia</h1>
                                  }
                                </table>
                              </div>
                            </>
                          )}
                        </FormInitial.List>
                      </DynamicCardForm>
                    )
                  },

                  {
                    key: 'existencias',
                    label: 'Existencias',
                    customContent: (
                      <DynamicCardForm
                        title="EXISTENCIAS"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <Spin spinning={this.state.loadingExistencias}>
                          <Table
                            size="small"
                            pagination={false}
                            rowKey={(fila, index) => fila._id || index}
                            // Sin filas no hay nada que desplazar, y con scroll.x el "No Data" de antd 4
                            // toma un ancho fijo medido que oscila contra la scrollbar de la página.
                            scroll={this.state.existencias?.length > 0 ? { x: 'max-content' } : undefined}
                            dataSource={this.state.existencias}
                            expandable={
                              this.state.equivalenciasExistencias.length > 0
                                ? {
                                  expandedRowRender: (fila) => (
                                    <Table
                                      size="small"
                                      pagination={false}
                                      rowKey={(equivalencia, index) => equivalencia._id || index}
                                      dataSource={this.state.equivalenciasExistencias.map(
                                        (equivalencia) => ({
                                          ...equivalencia,
                                          cantidadEquivalente: round10Decimals(
                                            (Number(fila.cantidad) || 0) *
                                            Number(equivalencia.equivalencia)
                                          ),
                                        })
                                      )}
                                      columns={[
                                        {
                                          title: 'Equivalencia',
                                          dataIndex: 'descripcion',
                                          key: 'descripcion',
                                        },
                                        {
                                          title: 'Unidad',
                                          dataIndex: 'unidadNombre',
                                          key: 'unidadNombre',
                                          align: 'center',
                                          render: (valor) => valor || '-',
                                        },
                                        {
                                          title: 'Factor',
                                          dataIndex: 'equivalencia',
                                          key: 'equivalencia',
                                          align: 'center',
                                          render: (valor) => `x${valor}`,
                                        },
                                        {
                                          title: 'Existencia',
                                          dataIndex: 'cantidadEquivalente',
                                          key: 'cantidadEquivalente',
                                          align: 'right',
                                          render: (valor) => (
                                            <strong>{this.formatoCantidadExistencia(valor)}</strong>
                                          ),
                                        },
                                        {
                                          title: 'Venta',
                                          dataIndex: 'venta',
                                          key: 'venta',
                                          align: 'center',
                                          render: (valor) =>
                                            valor ? (
                                              <Tag color="green">Si</Tag>
                                            ) : (
                                              <Tag>No</Tag>
                                            ),
                                        },
                                      ]}
                                    />
                                  ),
                                }
                                : undefined
                            }
                            columns={[
                              {
                                title: 'Proyecto',
                                dataIndex: ['proyecto', 'nombre'],
                                key: 'proyecto',
                              },
                              {
                                title: 'Unidad',
                                dataIndex: ['unidad', 'nombre'],
                                key: 'unidad',
                                align: 'center',
                              },
                              {
                                title: 'Cantidad',
                                dataIndex: 'cantidad',
                                key: 'cantidad',
                                align: 'right',
                                render: (valor) => this.formatoCantidadExistencia(valor),
                              },
                              {
                                title: 'Estado',
                                dataIndex: 'estado',
                                key: 'estado',
                                align: 'center',
                                render: (valor) =>
                                  valor === 2 ? (
                                    <Tag color="blue">Apartado</Tag>
                                  ) : (
                                    <Tag color="green">Disponible</Tag>
                                  ),
                              },
                            ]}
                          />
                        </Spin>
                      </DynamicCardForm>
                    )
                  },

                  {
                    key: 'logistica',
                    label: 'Logística',
                    customContent: (
                      <DynamicCardForm
                        title="LOGÍSTICA"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <Spin spinning={this.state.loadingLogistica}>
                          <Card size="small" title="Tiempo de entrega manual" style={{ marginBottom: 16 }}>
                            <Row align="middle" gutter={8}>
                              <Col>
                                <InputNumber
                                  value={this.state.tiempoEntregaManualDias}
                                  min={1}
                                  placeholder="Días"
                                  onChange={(valor) => this.setState({ tiempoEntregaManualDias: valor })}
                                />
                              </Col>
                              <Col>
                                <Button
                                  type="primary"
                                  loading={this.state.guardandoTiempoEntregaManual}
                                  onClick={() => this.guardarTiempoEntregaManual()}
                                >
                                  Guardar
                                </Button>
                              </Col>
                              <Col flex="auto">
                                <Text type="secondary">
                                  Si se captura, este valor tiene prioridad sobre el cálculo automático de proveedores para calcular los controles de abajo.
                                </Text>
                              </Col>
                            </Row>
                            {this.state.tiempoEntregaManualDias ? (
                              <Alert
                                type="info"
                                showIcon
                                style={{ marginTop: 10 }}
                                message={`Los controles se están calculando con el tiempo de entrega manual (${this.state.tiempoEntregaManualDias} días).`}
                              />
                            ) : null}
                          </Card>

                          <Card size="small" title="Proveedores" style={{ marginBottom: 16 }}>
                            <Table
                              size="small"
                              pagination={false}
                              rowKey={(fila, index) => index}
                              scroll={this.state.entregasPProveedor?.length > 0 ? { x: 'max-content' } : undefined}
                              dataSource={this.state.entregasPProveedor}
                              columns={[
                                { title: 'Proveedor', dataIndex: 'proveedorNombre', key: 'proveedorNombre' },
                                { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad', align: 'center' },
                                { title: 'Demora Días', dataIndex: 'demora', key: 'demora', align: 'right', render: (valor) => `${valor} días` },
                              ]}
                            />
                          </Card>

                          <Card size="small" title="Ventas" style={{ marginBottom: 16 }}>
                            <Table
                              size="small"
                              pagination={false}
                              rowKey={(fila, index) => index}
                              scroll={this.state.ventasPProyecto?.length > 0 ? { x: 'max-content' } : undefined}
                              dataSource={this.state.ventasPProyecto}
                              columns={[
                                { title: 'Proyecto', dataIndex: 'proyectoNombre', key: 'proyectoNombre' },
                                { title: 'Cantidad', dataIndex: 'cantidad', key: 'cantidad', align: 'center' },
                                { title: 'Prom. Diario', dataIndex: 'promedioDiario', key: 'promedioDiario', align: 'right' },
                                { title: 'Prom. Semanal', dataIndex: 'promedioSemanal', key: 'promedioSemanal', align: 'right' },
                                { title: 'Prom. Mensual', dataIndex: 'promedioMensual', key: 'promedioMensual', align: 'right' },
                              ]}
                            />
                          </Card>

                          <Card
                            size="small"
                            title="Controles"
                            extra={
                              <Button
                                type="primary"
                                size="small"
                                icon={<PlusOutlined />}
                                onClick={() => this.abrirAgregarControlLogistica()}
                              >
                                Agregar Control
                              </Button>
                            }
                          >
                            <Table
                              size="small"
                              pagination={false}
                              rowKey={(fila, index) => index}
                              scroll={this.state.controlesFilas?.length > 0 ? { x: 'max-content' } : undefined}
                              dataSource={this.state.controlesFilas}
                              columns={[
                                { title: 'Proyecto', dataIndex: 'proyectoNombre', key: 'proyectoNombre', render: (valor) => valor || 'General' },
                                {
                                  title: 'Propuesto (Min / Max)',
                                  key: 'propuesto',
                                  align: 'center',
                                  render: (_, fila) => (
                                    fila.minPropuesto !== null && fila.minPropuesto !== undefined
                                      ? `${fila.minPropuesto} / ${fila.maxPropuesto}`
                                      : <Text type="secondary">Sin datos suficientes</Text>
                                  ),
                                },
                                {
                                  title: 'Min actual',
                                  key: 'min',
                                  align: 'center',
                                  render: (_, fila, index) => (
                                    <InputNumber
                                      value={fila.min}
                                      min={0}
                                      style={this.controlDifiereDePropuesto(fila, 'min') ? estiloControlSugerido : { width: 90 }}
                                      onChange={(valor) => this.actualizarValorControlFila(index, 'min', valor)}
                                    />
                                  ),
                                },
                                {
                                  title: 'Max actual',
                                  key: 'max',
                                  align: 'center',
                                  render: (_, fila, index) => (
                                    <InputNumber
                                      value={fila.max}
                                      min={0}
                                      style={this.controlDifiereDePropuesto(fila, 'max') ? estiloControlSugerido : { width: 90 }}
                                      onChange={(valor) => this.actualizarValorControlFila(index, 'max', valor)}
                                    />
                                  ),
                                },
                                {
                                  title: '',
                                  key: 'acciones',
                                  align: 'center',
                                  render: (_, fila, index) => (
                                    <Row gutter={4} justify="center" wrap={false}>
                                      <Col>
                                        <Button
                                          size="small"
                                          disabled={fila.minPropuesto === null || fila.minPropuesto === undefined}
                                          onClick={() => this.aplicarSugerido(index)}
                                        >
                                          Aplicar sugerido
                                        </Button>
                                      </Col>
                                      <Col>
                                        <Button
                                          size="small"
                                          type="primary"
                                          loading={fila.guardando}
                                          onClick={() => this.guardarControlFila(index)}
                                        >
                                          Guardar
                                        </Button>
                                      </Col>
                                    </Row>
                                  ),
                                },
                              ]}
                            />
                          </Card>
                        </Spin>
                      </DynamicCardForm>
                    )
                  },

                  {
                    key: 'historialCostos',
                    label: 'Historial de Costos',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm
                        title="HISTORIAL DE COSTOS"
                        lg="100%"
                        style={{ marginTop: 10 }}
                      >
                        <TableItem
                          size="small"
                          defaultPageSize={20}
                          dataSource={this.historialCostosOrdenado()}
                          columns={[
                            {
                              title: "Fecha",
                              dataIndex: "fecha",
                              key: "fecha",
                              width: "16%",
                              render: (value) => (
                                <span style={{ fontWeight: 600 }}>
                                  {moment(value).format("DD/MM/YYYY HH:mm")}
                                </span>
                              ),
                            },
                            {
                              title: "Costo",
                              dataIndex: "costo",
                              key: "costo",
                              width: "14%",
                              align: "right",
                              render: (value) => (
                                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontSize: 12, background: "rgba(107, 114, 128, 0.10)", border: "1px solid rgba(107, 114, 128, 0.25)", color: "rgba(31, 41, 55, 1)" }}>
                                  {dineroDisabledMask(value || 0)}
                                </span>
                              ),
                            },
                            {
                              title: "Variación",
                              dataIndex: "variacion",
                              key: "variacion",
                              width: "16%",
                              align: "right",
                              render: (variacion) => {
                                // El primer renglon del historial no tiene contra que compararse.
                                if (!variacion) return <span style={{ color: "rgba(156, 163, 175, 1)" }}>—</span>;

                                if (variacion.monto === 0) {
                                  return <span style={{ color: "rgba(107, 114, 128, 1)", fontSize: 12 }}>= sin cambio</span>;
                                }

                                // En compras la mala noticia es que el costo SUBA: rojo arriba, verde abajo.
                                const subio = variacion.monto > 0;
                                const estilo = subio
                                  ? { background: "rgba(239, 68, 68, 0.10)", border: "1px solid rgba(239, 68, 68, 0.35)", color: "rgba(153, 27, 27, 1)" }
                                  : { background: "rgba(34, 197, 94, 0.12)", border: "1px solid rgba(34, 197, 94, 0.35)", color: "rgba(22, 101, 52, 1)" };

                                return (
                                  <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontWeight: 600, fontSize: 12, ...estilo }}>
                                    {subio ? "▲" : "▼"} {dineroDisabledMask(Math.abs(variacion.monto))}
                                    {variacion.porcentaje !== null
                                      ? ` (${subio ? "+" : "-"}${Math.abs(variacion.porcentaje).toFixed(1)}%)`
                                      : ""}
                                  </span>
                                );
                              },
                            },
                            {
                              title: "Origen",
                              dataIndex: "origen",
                              key: "origen",
                              width: "14%",
                              filters: [
                                { text: "Compra", value: "compra" },
                                { text: "Manual", value: "manual" },
                                { text: "Producción", value: "produccion" },
                                { text: "Inventario", value: "inventario" },
                                { text: "Sin registro", value: "sinRegistro" },
                              ],
                              onFilter: (value, record) => record.origen === value,
                              render: (origen) => {
                                const ORIGENES = {
                                  compra: { texto: "Compra", color: "green" },
                                  manual: { texto: "Manual", color: "blue" },
                                  produccion: { texto: "Producción", color: "purple" },
                                  inventario: { texto: "Inventario", color: "orange" },
                                };
                                // Los renglones anteriores a que se guardara el origen son
                                // irrecuperables: se marcan asi en vez de adivinar.
                                const datos = ORIGENES[origen] || { texto: "Sin registro", color: "default" };
                                return (
                                  <Tag color={datos.color} className="square-tag">
                                    {datos.texto}
                                  </Tag>
                                );
                              },
                            },
                            {
                              title: "Documento",
                              dataIndex: "documentoFolio",
                              key: "documentoFolio",
                              width: "20%",
                              render: (folio, record) => {
                                if (!folio && !record.documentoId) {
                                  return <span style={{ color: "rgba(156, 163, 175, 1)" }}>—</span>;
                                }

                                const PREFIJOS = {
                                  OrdenDeCompra: "O/C",
                                  Factura: "Factura",
                                  Remision: "Remisión",
                                  Produccion: "O/P",
                                };
                                const prefijo = PREFIJOS[record.documentoTipo] || "";
                                // Produccion e inventario no tienen modal: se muestra el folio sin boton.
                                const sePuedeAbrir =
                                  record.documentoId &&
                                  ["OrdenDeCompra", "Factura", "Remision"].includes(record.documentoTipo);

                                return (
                                  <span>
                                    <strong>{`${prefijo} ${folio || ""}`.trim()}</strong>
                                    {sePuedeAbrir && (
                                      <Tooltip title={`Ver ${prefijo}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        {/* lessTime: ButtonItem se autobloquea 1s tras cada clic; aqui solo
                                            abre un modal de lectura, y esperar entre documento y documento estorba. */}
                                        <ButtonItem
                                          type="text"
                                          lessTime
                                          onClick={() => this.abrirDocumentoHistorial(record)}
                                          icon={<EyeOutlined />}
                                        />
                                      </Tooltip>
                                    )}
                                  </span>
                                );
                              },
                            },
                            {
                              title: "Usuario",
                              dataIndex: "nombreUsuario",
                              key: "nombreUsuario",
                              width: "20%",
                              render: (value) => (
                                <span style={{ fontWeight: 600 }}>{value}</span>
                              ),
                            },
                          ]}
                        />
                      </DynamicCardForm>
                    )
                  },
                  {
                    key: 'kardex',
                    label: 'Kardex',
                    customContent: (
                      <DynamicCardForm title="KARDEX" lg="100%" style={{ marginTop: 10 }}>
                        <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 10 }}>
                          <SelectItem
                            placeholder="Proyecto"
                            value={this.state.proyectoKardex}
                            onChange={(value) => this.consultarKardex(value)}
                            width={250}
                          >
                            <Option value={0}>Todos</Option>
                            {this.state.objetoProyectosKardex}
                          </SelectItem>
                          {this.state.kardex.filter((value) => value.esMovimientoApartado).length > 0 && (
                            <ButtonItem
                              type={this.state.mostrarApartados ? "primary" : "default"}
                              onClick={() => this.setState({ mostrarApartados: !this.state.mostrarApartados })}
                            >
                              {this.state.mostrarApartados
                                ? "Ocultar apartados"
                                : `Mostrar apartados (${this.state.kardex.filter((value) => value.esMovimientoApartado).length})`}
                            </ButtonItem>
                          )}
                        </div>
                        <TableItem
                          size="small"
                          loading={this.state.loadingKardex}
                          dataSource={this.state.mostrarApartados ? this.state.kardex : this.state.kardex.filter((value) => !value.esMovimientoApartado)}
                          pagination={false}
                          columns={[
                            {
                              title: "Fecha",
                              dataIndex: "createdAt",
                              key: "createdAt",
                              width: "10%",
                              render: (value) => (
                                <span style={{ fontWeight: 600 }}>
                                  {moment(value).locale("es").format("ll")}
                                </span>
                              ),
                            },
                            {
                              title: "Concepto",
                              dataIndex: "concepto",
                              key: "concepto",
                              width: "25%",
                              buscar: "concepto",
                              render: (value) => (
                                <span style={{ fontWeight: 600, color: "rgba(17, 24, 39, 1)" }}>{value}</span>
                              ),
                            },
                            {
                              title: "Proyecto",
                              dataIndex: "proyecto",
                              key: "proyecto",
                              width: "15%",
                              render: (value) => (
                                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontSize: 12, background: "rgba(59, 130, 246, 0.10)", border: "1px solid rgba(59, 130, 246, 0.25)", color: "rgba(30, 64, 175, 1)" }}>
                                  {value?.nombre}
                                </span>
                              ),
                            },
                            {
                              title: "Entradas",
                              key: "entradas",
                              width: "10%",
                              align: "right",
                              render: (_, record) => !record.salida ? (
                                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontWeight: 600, fontSize: 12, background: "rgba(34, 197, 94, 0.12)", border: "1px solid rgba(34, 197, 94, 0.35)", color: "rgba(22, 101, 52, 1)", minWidth: 88, textAlign: "right" }}>
                                  {round10Decimals(record.cantidad || 0).toFixed(4)}
                                </span>
                              ) : "-",
                            },
                            {
                              title: "Salidas",
                              key: "salidas",
                              width: "10%",
                              align: "right",
                              render: (_, record) => record.salida ? (
                                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontWeight: 600, fontSize: 12, background: "rgba(239, 68, 68, 0.10)", border: "1px solid rgba(239, 68, 68, 0.35)", color: "rgba(153, 27, 27, 1)", minWidth: 88, textAlign: "right" }}>
                                  {round10Decimals(record.cantidad || 0).toFixed(4)}
                                </span>
                              ) : "-",
                            },
                            {
                              title: "Costo",
                              dataIndex: "costo",
                              key: "costo",
                              width: "10%",
                              align: "right",
                              render: (value) => (
                                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 999, fontSize: 12, background: "rgba(107, 114, 128, 0.10)", border: "1px solid rgba(107, 114, 128, 0.25)", color: "rgba(31, 41, 55, 1)" }}>
                                  {dineroDisabledMask(value || 0)}
                                </span>
                              ),
                            },
                            {
                              title: "Saldo",
                              dataIndex: "saldo",
                              key: "saldo",
                              width: "10%",
                              align: "right",
                              render: (value) => (
                                <span style={{ fontWeight: 700 }}>
                                  {round10Decimals(value || 0).toFixed(4)}
                                </span>
                              ),
                            },
                            {
                              title: "Usuario",
                              dataIndex: "usuario",
                              key: "usuario",
                              width: "10%",
                              render: (value) => (
                                <span style={{ fontWeight: 600 }}>{value?.nombre}</span>
                              ),
                            },
                            {
                              title: "Acciones",
                              dataIndex: "acciones",
                              key: "acciones",
                              width: "10%",
                              render: (value, record) => {
                                let botones = []

                                if (record.ventaId){
                                  botones.push(
                                    <Tooltip key="verVenta" title="Ver Venta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                      <ButtonItem
                                        type="text"
                                        onClick={() => this.abrirModalVerVenta(record.ventaId)}
                                        icon={<EyeOutlined />}
                                      />
                                    </Tooltip>
                                  )
                                }

                                // Los dos if son independientes a proposito: hoy
                                // aumentarInventario llena uno u otro, pero si llegaran
                                // los dos se ven ambos botones.
                                if (record.ordendecompraId){
                                  botones.push(
                                    <Tooltip key="verOrdenCompra" title="Ver Orden de Compra" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                      <ButtonItem
                                        type="text"
                                        onClick={() => this.abrirModalVerOrdenCompra(record.ordendecompraId)}
                                        icon={<EyeOutlined />}
                                      />
                                    </Tooltip>
                                  )
                                }

                                if (record.facturaId){
                                  botones.push(
                                    <Tooltip key="verFacturaCompra" title="Ver Factura de Compra" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                      <ButtonItem
                                        type="text"
                                        onClick={() => this.abrirModalVerFacturaCompra(record.facturaId)}
                                        icon={<EyeOutlined />}
                                      />
                                    </Tooltip>
                                  )
                                }

                                return botones
                              },
                            },
                          ]}
                        />
                      </DynamicCardForm>
                    ),
                  },
                  {
                    key: 'proyecciones',
                    label: 'Proyecciones',
                    customContent: (() => {
                      const agrupado = this.state.agruparProyecciones;

                      const agrupar = (lista, llave) => {
                        const map = {};
                        (lista || []).forEach(item => {
                          const key = item.proyecto || 'Sin proyecto';
                          if (!map[key]) map[key] = { proyecto: key, cantidad: 0, apartado: 0 };
                          map[key].cantidad += item.cantidad || 0;
                          map[key].apartado += item.apartado || 0;
                        });
                        return Object.values(map);
                      };

                      const thStyle = {
                        padding: '8px 12px',
                        background: '#f5f5f5',
                        fontWeight: 600,
                        fontSize: 12,
                        color: '#374151',
                        borderBottom: '2px solid #e5e7eb',
                        whiteSpace: 'nowrap',
                      };
                      const tdStyle = (align = 'left') => ({
                        padding: '7px 12px',
                        fontSize: 13,
                        color: '#111827',
                        borderBottom: '1px solid #f3f4f6',
                        textAlign: align,
                      });

                      // conApartado agrega una columna, por eso el colSpan del mensaje
                      // vacio no es el mismo en las tres secciones.
                      const tablaSinDatos = (msg, conApartado = false) => (
                        <tr>
                          <td colSpan={(agrupado ? 2 : 4) + (conApartado ? 1 : 0)} style={{ textAlign: 'center', padding: '16px 12px', color: '#9ca3af', fontSize: 13 }}>
                            {msg}
                          </td>
                        </tr>
                      );

                      const seccionStyle = (color) => ({
                        marginBottom: 16,
                        border: `1px solid ${color}30`,
                        borderRadius: 8,
                        overflow: 'hidden',
                      });
                      const headerSectionStyle = (color) => ({
                        background: `${color}12`,
                        borderBottom: `1px solid ${color}30`,
                        padding: '7px 14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      });
                      const dotStyle = (color) => ({
                        width: 9,
                        height: 9,
                        borderRadius: '50%',
                        background: color,
                        display: 'inline-block',
                      });
                      const badgeStyle = (color, bg) => ({
                        display: 'inline-block',
                        padding: '2px 10px',
                        borderRadius: 999,
                        fontWeight: 600,
                        fontSize: 12,
                        background: bg,
                        border: `1px solid ${color}`,
                        color: color,
                      });

                      const pedidosData    = agrupado ? agrupar(this.state.proyecciones?.pedidos)           : (this.state.proyecciones?.pedidos || []);
                      const ventasData     = agrupado ? agrupar(this.state.proyecciones?.ventasNoEntregadas) : (this.state.proyecciones?.ventasNoEntregadas || []);
                      const ordenesData    = agrupado ? agrupar(this.state.proyecciones?.ordenesPendientes)  : (this.state.proyecciones?.ordenesPendientes || []);
                      const existenciasData = this.state.proyecciones?.existencias || [];

                      const formatoCantidad = (valor) => round10Decimals(Number(valor) || 0).toLocaleString(undefined, { maximumFractionDigits: 4 });
                      const totalDisponible = existenciasData.reduce((acum, item) => acum + (item.disponible || 0), 0);
                      const totalApartado   = existenciasData.reduce((acum, item) => acum + (item.apartado || 0), 0);

                      return (
                        <DynamicCardForm title="PROYECCIONES" lg="100%" style={{ marginTop: 10 }}>
                          <Spin spinning={this.state.loadingProyecciones}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                              <ButtonItem
                                size="small"
                                onClick={() => this.setState({ agruparProyecciones: !agrupado })}
                                style={{ fontSize: 12 }}
                              >
                                {agrupado ? 'Ver desglose' : 'Agrupar por proyecto'}
                              </ButtonItem>
                            </div>

                            {/* EXISTENCIAS POR PROYECTO */}
                            <div style={seccionStyle('#00BFD6')}>
                              <div style={headerSectionStyle('#00BFD6')}>
                                <span style={dotStyle('#00BFD6')} />
                                <span style={{ fontWeight: 600, fontSize: 13, color: '#005f6b' }}>Existencias por Proyecto</span>
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      <th style={thStyle}>Proyecto</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Disponible</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Apartado</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {existenciasData.length > 0 ? (
                                      <>
                                        {existenciasData.map((item, i) => (
                                          <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f0fdff' }}>
                                            <td style={tdStyle()}>
                                              <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, background: 'rgba(59,130,246,0.10)', border: '1px solid rgba(59,130,246,0.25)', color: 'rgba(30,64,175,1)' }}>
                                                {item.proyecto}
                                              </span>
                                            </td>
                                            <td style={tdStyle('right')}>
                                              <span style={badgeStyle('rgba(0,95,107,1)', 'rgba(0,191,214,0.12)')}>
                                                {formatoCantidad(item.disponible)}
                                              </span>
                                            </td>
                                            <td style={tdStyle('right')}>
                                              <span style={badgeStyle('rgba(146,64,14,1)', 'rgba(245,158,11,0.12)')}>
                                                {formatoCantidad(item.apartado)}
                                              </span>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr style={{ background: '#f9fafb' }}>
                                          <td style={{ ...tdStyle(), fontWeight: 600 }}>Total</td>
                                          <td style={{ ...tdStyle('right'), fontWeight: 600 }}>{formatoCantidad(totalDisponible)}</td>
                                          <td style={{ ...tdStyle('right'), fontWeight: 600 }}>{formatoCantidad(totalApartado)}</td>
                                        </tr>
                                      </>
                                    ) : (
                                      <tr>
                                        <td colSpan={3} style={{ textAlign: 'center', padding: '16px 12px', color: '#9ca3af', fontSize: 13 }}>
                                          Sin existencias en ningún proyecto
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {/* PEDIDOS */}
                            <div style={seccionStyle('#f59e0b')}>
                              <div style={headerSectionStyle('#f59e0b')}>
                                <span style={dotStyle('#f59e0b')} />
                                <span style={{ fontWeight: 600, fontSize: 13, color: '#92400e' }}>En Pedido</span>
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      {!agrupado && <th style={thStyle}>Folio</th>}
                                      {!agrupado && <th style={thStyle}>Cliente</th>}
                                      <th style={thStyle}>Proyecto</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Cantidad</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Apartado</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pedidosData.length > 0 ? pedidosData.map((item, i) => (
                                      <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fffbf0' }}>
                                        {!agrupado && <td style={tdStyle('center')}>{item.folio}</td>}
                                        {!agrupado && <td style={tdStyle()}>{item.cliente}</td>}
                                        <td style={tdStyle()}>
                                          <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, background: 'rgba(59,130,246,0.10)', border: '1px solid rgba(59,130,246,0.25)', color: 'rgba(30,64,175,1)' }}>
                                            {item.proyecto}
                                          </span>
                                        </td>
                                        <td style={tdStyle('right')}>
                                          <span style={badgeStyle('rgba(146,64,14,1)', 'rgba(245,158,11,0.12)')}>
                                            {item.cantidad}
                                          </span>
                                        </td>
                                        <td style={tdStyle('right')}>
                                          {item.apartado > 0 ? (
                                            <span style={badgeStyle('rgba(146,64,14,1)', 'rgba(245,158,11,0.12)')}>
                                              {formatoCantidad(item.apartado)}
                                            </span>
                                          ) : (
                                            <span style={{ color: '#9ca3af', fontSize: 12 }}>-</span>
                                          )}
                                        </td>
                                      </tr>
                                    )) : tablaSinDatos('Sin pedidos pendientes', true)}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {/* VENTAS NO ENTREGADAS */}
                            <div style={seccionStyle('#ef4444')}>
                              <div style={headerSectionStyle('#ef4444')}>
                                <span style={dotStyle('#ef4444')} />
                                <span style={{ fontWeight: 600, fontSize: 13, color: '#991b1b' }}>Ventas No Entregadas</span>
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      {!agrupado && <th style={thStyle}>Folio</th>}
                                      {!agrupado && <th style={thStyle}>Cliente</th>}
                                      <th style={thStyle}>Proyecto</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Cantidad</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Apartado</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ventasData.length > 0 ? ventasData.map((item, i) => (
                                      <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fff5f5' }}>
                                        {!agrupado && <td style={tdStyle('center')}>{item.folio}</td>}
                                        {!agrupado && <td style={tdStyle()}>{item.cliente}</td>}
                                        <td style={tdStyle()}>
                                          <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, background: 'rgba(59,130,246,0.10)', border: '1px solid rgba(59,130,246,0.25)', color: 'rgba(30,64,175,1)' }}>
                                            {item.proyecto}
                                          </span>
                                        </td>
                                        <td style={tdStyle('right')}>
                                          <span style={badgeStyle('rgba(153,27,27,1)', 'rgba(239,68,68,0.10)')}>
                                            {item.cantidad}
                                          </span>
                                        </td>
                                        <td style={tdStyle('right')}>
                                          {item.apartado > 0 ? (
                                            <span style={badgeStyle('rgba(146,64,14,1)', 'rgba(245,158,11,0.12)')}>
                                              {formatoCantidad(item.apartado)}
                                            </span>
                                          ) : (
                                            <span style={{ color: '#9ca3af', fontSize: 12 }}>-</span>
                                          )}
                                        </td>
                                      </tr>
                                    )) : tablaSinDatos('Sin ventas no entregadas', true)}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {/* ORDENES PENDIENTES */}
                            <div style={seccionStyle('#10b981')}>
                              <div style={headerSectionStyle('#10b981')}>
                                <span style={dotStyle('#10b981')} />
                                <span style={{ fontWeight: 600, fontSize: 13, color: '#065f46' }}>Órdenes Pendientes de Recibir</span>
                              </div>
                              <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      {!agrupado && <th style={thStyle}>Folio</th>}
                                      {!agrupado && <th style={thStyle}>Proveedor</th>}
                                      <th style={thStyle}>Proyecto</th>
                                      <th style={{ ...thStyle, textAlign: 'right' }}>Cantidad</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ordenesData.length > 0 ? ordenesData.map((item, i) => (
                                      <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f0fdf9' }}>
                                        {!agrupado && <td style={tdStyle('center')}>{item.folio}</td>}
                                        {!agrupado && <td style={tdStyle()}>{item.proveedor}</td>}
                                        <td style={tdStyle()}>
                                          <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, background: 'rgba(59,130,246,0.10)', border: '1px solid rgba(59,130,246,0.25)', color: 'rgba(30,64,175,1)' }}>
                                            {item.proyecto}
                                          </span>
                                        </td>
                                        <td style={tdStyle('right')}>
                                          <span style={badgeStyle('rgba(6,95,70,1)', 'rgba(16,185,129,0.12)')}>
                                            {item.cantidad}
                                          </span>
                                        </td>
                                      </tr>
                                    )) : tablaSinDatos('Sin órdenes pendientes de recibir')}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Spin>
                        </DynamicCardForm>
                      );
                    })(),
                  },

                  {
                    key: 'extra',
                    label: 'Extra',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm title="PROYECTOS" lg="100%" style={{ marginTop: 10 }}>
                        <FormInitial.List name="proyectos">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ name }, arrayKey) => (
                                <Row key={arrayKey} gutter={8} align="middle">
                                  <Col span={22}>
                                    <FormItem
                                      name={[name, "proyectoId"]}
                                      fieldKey={[arrayKey, "proyectoId"]}
                                      required
                                      margin
                                      noStyle
                                    >
                                      <SelectProyectosItem
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                        width="100%"
                                        placeholder="Proyecto"
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col span={2}>
                                    <div style={{ textAlign: "center" }}>
                                      <ButtonItem
                                        type="dashed"
                                        rojo2
                                        icon={<DeleteOutlined />}
                                        onClick={() => remove(name)}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              ))}
                              <div style={{ textAlign: "center", marginTop: 12 }}>
                                <ButtonItem
                                  type="primary"
                                  cyan
                                  onClick={() => add()}
                                  icon={<PlusOutlined />}
                                >
                                  Agregar
                                </ButtonItem>
                              </div>
                            </>
                          )}
                        </FormInitial.List>
                      </DynamicCardForm>
                    ),
                  },
                  ...(this.props.moduloWms && this.state.inventariable ? [{
                    key: 'ubicacionesPredeterminadas',
                    label: 'Ubicaciones Predeterminadas',
                    forceRender: true,
                    customContent: (
                      <DynamicCardForm title="UBICACIONES PREDETERMINADAS POR ALMACÉN" lg="100%" style={{ marginTop: 10 }}>
                        {this.state.ubicacionesPredeterminadas.length === 0 && (
                          <div style={{ color: "#999", marginBottom: 12 }}>
                            Aún no hay ubicaciones predeterminadas. Agrega un almacén y su ubicación.
                          </div>
                        )}
                        {this.state.ubicacionesPredeterminadas.map((entrada, index) => (
                          <Row key={index} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                            <Col span={11}>
                              <SelectProyectosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                width="100%"
                                placeholder="Almacén"
                                value={entrada.proyectoId}
                                onChange={(proyectoId) =>
                                  this.actualizarProyectoUbicacionPredeterminada(index, proyectoId)
                                }
                              />
                            </Col>
                            <Col span={11}>
                              <SelectUbicacionesProyectoItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                proyectoId={entrada.proyectoId}
                                width="100%"
                                value={entrada.ubicacionId}
                                onChange={(ubicacionId) =>
                                  this.actualizarUbicacionEnFilaPredeterminada(index, ubicacionId)
                                }
                              />
                            </Col>
                            <Col span={2}>
                              <div style={{ textAlign: "center" }}>
                                <ButtonItem
                                  type="dashed"
                                  rojo2
                                  icon={<DeleteOutlined />}
                                  onClick={() => this.eliminarFilaUbicacionPredeterminada(index)}
                                />
                              </div>
                            </Col>
                          </Row>
                        ))}
                        <div style={{ textAlign: "center", marginTop: 12 }}>
                          <ButtonItem
                            type="primary"
                            cyan
                            onClick={this.agregarFilaUbicacionPredeterminada}
                            icon={<PlusOutlined />}
                          >
                            Agregar
                          </ButtonItem>
                        </div>
                      </DynamicCardForm>
                    ),
                  }] : []),
                  // Sin forceRender: el contenido se monta (y recien ahi se piden los datos)
                  // al abrir el tab. onFinish reenvia los datosCategorias originales si
                  // nunca se abrio, para no borrarlos al guardar.
                  ...(this.state.hayCategoriasInsumo ? [{
                    key: 'categorias',
                    label: 'Categorías',
                    customContent: (() => {
                      const { grupos, sueltas } = this.state.gruposCategorias;

                      const renderFormItemCat = (cat) => (
                        <FormItem
                          key={cat._id}
                          label={cat.nombre}
                          name={["datosCategoriasMap", cat._id]}
                          margin
                          tooltip={cat.descripcion || `Tipo: ${cat.tipoDato}`}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <SelectValorCategoriaItem
                            categoria={cat}
                            valores={this.state.valoresPorCategoria[cat._id] || []}
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            onValorAgregado={() => this.consultarValoresCategoria(cat._id)}
                          />
                        </FormItem>
                      );

                      return (
                        <Spin spinning={this.state.loadingCategorias}>
                          <div style={{ minHeight: 120 }}>
                          {grupos.map((info) => (
                            <DynamicCardForm
                              key={info.padreId}
                              title={info.nombre.toUpperCase()}
                              lg="100%"
                              style={{ marginTop: 10 }}
                            >
                              {info.hijas.map(renderFormItemCat)}
                            </DynamicCardForm>
                          ))}
                          {sueltas.length > 0 && (
                            <DynamicCardForm
                              key="sin-agrupar"
                              title={grupos.length > 0 ? "OTROS CAMPOS" : "CATEGORÍAS"}
                              lg="100%"
                              style={{ marginTop: 10 }}
                            >
                              {sueltas.map(renderFormItemCat)}
                            </DynamicCardForm>
                          )}
                          {this.state.categoriasCargadas &&
                            grupos.length === 0 &&
                            sueltas.length === 0 && (
                              <div style={{ textAlign: "center", padding: 24, color: "#8c8c8c" }}>
                                No hay categorías configuradas para esta familia
                              </div>
                            )}
                          </div>
                        </Spin>
                      );
                    })(),
                  }] : []),
                  ]}
                />
                </div>
            </Form>
          </Spin>
        </div>
        <ModalItem
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
          spinning={false}
          width={450}
        >
          <img alt="vista previa" style={{ width: "100%" }} src={previewImage} />
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <a
              href={previewImage}
              download={previewFile?.name || previewTitle || "imagen"}
              style={{ textDecoration: "none" }}
            >
              <ButtonItem
                type="primary"
                icon={<DownloadOutlined />}
                style={{ borderRadius: 6, paddingInline: 24 }}
              >
                Descargar imagen
              </ButtonItem>
            </a>
          </div>
        </ModalItem>
        <MandarCorreo
          visible={this.state.modalCorreoVenta}
          id={this.state.modalCorreoVentaId}
          cerrarMandarCorreo={this.cerrarMandarCorreoVenta.bind(this)}
        />
        <MandarCorreoOrdenDeCompra
          visible={this.state.modalCorreoOrdenCompra}
          id={this.state.modalCorreoOrdenCompraId}
          cerrarMandarCorreoOrdenDeCompra={this.cerrarModalVerOrdenCompra.bind(this)}
        />
        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreoFacturaCompra}
          id={this.state.modalCorreoFacturaCompraId}
          cerrarModalMandarCorreoFacturas={this.cerrarModalVerFacturaCompra.bind(this)}
        />
        <AgregarUnidad
          visible={this.state.modalAgregarUnidad}
          cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)}
        />
        <AgregarFamilia
          visible={this.state.modalAgregarFamilia}
          cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)}
        />
        <AsignarProveedor
          visible={this.state.modalAsignarProveedor}
          insumoId={this.state.id}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          cerrarAsignarProveedor={this.cerrarAsignarProveedor.bind(this)}
        />
        <AgregarControlLogistica
          visible={this.state.modalAgregarControlLogistica}
          insumoId={this.state.id}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          proyectosExistentes={this.state.controlesFilas.map((fila) => (fila.proyectoId ? fila.proyectoId.toString() : null))}
          cerrarAgregarControlLogistica={this.cerrarAgregarControlLogistica.bind(this)}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <ModalBusquedaURREA
          visible={this.state.modalBusquedaURREA}
          onClose={this.cerrarModalBusquedaURREA}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          codigoURREA={this.state.codigoURREA}
          onConfirm={this.handleConfirmProducto}

        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    envios: state.empresa.envios,
    marbetes: state.empresa.marbetes,
    fletes: state.empresa.fletes,
    lotesCaducidades: state.empresa.lotesCaducidades,
    taxidermia: state.empresa.taxidermia,
    escuela: state.empresa.escuela,
    moduloWms: state.empresa.moduloWms,
    permisoBloquearEdicionCosto:
      state.user.tipo !== 0 &&
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a70c5b4669284206d939a0e"
      )?.activado,
  };
};

export default connect(mapStateToProps)(EditarInsumo);